var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/.pnpm/dayjs@1.11.21/node_modules/dayjs/dayjs.min.js
var require_dayjs_min = __commonJS({
  "../../node_modules/.pnpm/dayjs@1.11.21/node_modules/dayjs/dayjs.min.js"(exports, module) {
    !(function(t, e) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs = e();
    })(exports, (function() {
      "use strict";
      var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(t2) {
        var e2 = ["th", "st", "nd", "rd"], n2 = t2 % 100;
        return "[" + t2 + (e2[(n2 - 20) % 10] || e2[n2] || e2[0]) + "]";
      } }, m = function(t2, e2, n2) {
        var r2 = String(t2);
        return !r2 || r2.length >= e2 ? t2 : "" + Array(e2 + 1 - r2.length).join(n2) + t2;
      }, v = { s: m, z: function(t2) {
        var e2 = -t2.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i2 = n2 % 60;
        return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i2, 2, "0");
      }, m: function t2(e2, n2) {
        if (e2.date() < n2.date()) return -t2(n2, e2);
        var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i2 = e2.clone().add(r2, c), s2 = n2 - i2 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), c);
        return +(-(r2 + (n2 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
      }, a: function(t2) {
        return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
      }, p: function(t2) {
        return { M: c, y: h, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: f }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
      }, u: function(t2) {
        return void 0 === t2;
      } }, g = "en", D = {};
      D[g] = M;
      var p = "$isDayjsObject", S = function(t2) {
        return t2 instanceof _ || !(!t2 || !t2[p]);
      }, w = function t2(e2, n2, r2) {
        var i2;
        if (!e2) return g;
        if ("string" == typeof e2) {
          var s2 = e2.toLowerCase();
          D[s2] && (i2 = s2), n2 && (D[s2] = n2, i2 = s2);
          var u2 = e2.split("-");
          if (!i2 && u2.length > 1) return t2(u2[0]);
        } else {
          var a2 = e2.name;
          D[a2] = e2, i2 = a2;
        }
        return !r2 && i2 && (g = i2), i2 || !r2 && g;
      }, O = function(t2, e2) {
        if (S(t2)) return t2.clone();
        var n2 = "object" == typeof e2 ? e2 : {};
        return n2.date = t2, n2.args = arguments, new _(n2);
      }, b = v;
      b.l = w, b.i = S, b.w = function(t2, e2) {
        return O(t2, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
      };
      var _ = (function() {
        function M2(t2) {
          this.$L = w(t2.locale, null, true), this.parse(t2), this.$x = this.$x || t2.x || {}, this[p] = true;
        }
        var m2 = M2.prototype;
        return m2.parse = function(t2) {
          this.$d = (function(t3) {
            var e2 = t3.date, n2 = t3.utc;
            if (null === e2) return /* @__PURE__ */ new Date(NaN);
            if (b.u(e2)) return /* @__PURE__ */ new Date();
            if (e2 instanceof Date) return new Date(e2);
            if ("string" == typeof e2 && !/Z$/i.test(e2)) {
              var r2 = e2.match($);
              if (r2) {
                var i2 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
                return n2 ? new Date(Date.UTC(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
              }
            }
            return new Date(e2);
          })(t2), this.init();
        }, m2.init = function() {
          var t2 = this.$d;
          this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
        }, m2.$utils = function() {
          return b;
        }, m2.isValid = function() {
          return !(this.$d.toString() === l);
        }, m2.isSame = function(t2, e2) {
          var n2 = O(t2);
          return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
        }, m2.isAfter = function(t2, e2) {
          return O(t2) < this.startOf(e2);
        }, m2.isBefore = function(t2, e2) {
          return this.endOf(e2) < O(t2);
        }, m2.$g = function(t2, e2, n2) {
          return b.u(t2) ? this[e2] : this.set(n2, t2);
        }, m2.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, m2.valueOf = function() {
          return this.$d.getTime();
        }, m2.startOf = function(t2, e2) {
          var n2 = this, r2 = !!b.u(e2) || e2, f2 = b.p(t2), l2 = function(t3, e3) {
            var i2 = b.w(n2.$u ? Date.UTC(n2.$y, e3, t3) : new Date(n2.$y, e3, t3), n2);
            return r2 ? i2 : i2.endOf(a);
          }, $2 = function(t3, e3) {
            return b.w(n2.toDate()[t3].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
          }, y2 = this.$W, M3 = this.$M, m3 = this.$D, v2 = "set" + (this.$u ? "UTC" : "");
          switch (f2) {
            case h:
              return r2 ? l2(1, 0) : l2(31, 11);
            case c:
              return r2 ? l2(1, M3) : l2(0, M3 + 1);
            case o:
              var g2 = this.$locale().weekStart || 0, D2 = (y2 < g2 ? y2 + 7 : y2) - g2;
              return l2(r2 ? m3 - D2 : m3 + (6 - D2), M3);
            case a:
            case d:
              return $2(v2 + "Hours", 0);
            case u:
              return $2(v2 + "Minutes", 1);
            case s:
              return $2(v2 + "Seconds", 2);
            case i:
              return $2(v2 + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, m2.endOf = function(t2) {
          return this.startOf(t2, false);
        }, m2.$set = function(t2, e2) {
          var n2, o2 = b.p(t2), f2 = "set" + (this.$u ? "UTC" : ""), l2 = (n2 = {}, n2[a] = f2 + "Date", n2[d] = f2 + "Date", n2[c] = f2 + "Month", n2[h] = f2 + "FullYear", n2[u] = f2 + "Hours", n2[s] = f2 + "Minutes", n2[i] = f2 + "Seconds", n2[r] = f2 + "Milliseconds", n2)[o2], $2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
          if (o2 === c || o2 === h) {
            var y2 = this.clone().set(d, 1);
            y2.$d[l2]($2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
          } else l2 && this.$d[l2]($2);
          return this.init(), this;
        }, m2.set = function(t2, e2) {
          return this.clone().$set(t2, e2);
        }, m2.get = function(t2) {
          return this[b.p(t2)]();
        }, m2.add = function(r2, f2) {
          var d2, l2 = this;
          r2 = Number(r2);
          var $2 = b.p(f2), y2 = function(t2) {
            var e2 = O(l2);
            return b.w(e2.date(e2.date() + Math.round(t2 * r2)), l2);
          };
          if ($2 === c) return this.set(c, this.$M + r2);
          if ($2 === h) return this.set(h, this.$y + r2);
          if ($2 === a) return y2(1);
          if ($2 === o) return y2(7);
          var M3 = (d2 = {}, d2[s] = e, d2[u] = n, d2[i] = t, d2)[$2] || 1, m3 = this.$d.getTime() + r2 * M3;
          return b.w(m3, this);
        }, m2.subtract = function(t2, e2) {
          return this.add(-1 * t2, e2);
        }, m2.format = function(t2) {
          var e2 = this, n2 = this.$locale();
          if (!this.isValid()) return n2.invalidDate || l;
          var r2 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i2 = b.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n2.weekdays, c2 = n2.months, f2 = n2.meridiem, h2 = function(t3, n3, i3, s3) {
            return t3 && (t3[n3] || t3(e2, r2)) || i3[n3].slice(0, s3);
          }, d2 = function(t3) {
            return b.s(s2 % 12 || 12, t3, "0");
          }, $2 = f2 || function(t3, e3, n3) {
            var r3 = t3 < 12 ? "AM" : "PM";
            return n3 ? r3.toLowerCase() : r3;
          };
          return r2.replace(y, (function(t3, r3) {
            return r3 || (function(t4) {
              switch (t4) {
                case "YY":
                  return String(e2.$y).slice(-2);
                case "YYYY":
                  return b.s(e2.$y, 4, "0");
                case "M":
                  return a2 + 1;
                case "MM":
                  return b.s(a2 + 1, 2, "0");
                case "MMM":
                  return h2(n2.monthsShort, a2, c2, 3);
                case "MMMM":
                  return h2(c2, a2);
                case "D":
                  return e2.$D;
                case "DD":
                  return b.s(e2.$D, 2, "0");
                case "d":
                  return String(e2.$W);
                case "dd":
                  return h2(n2.weekdaysMin, e2.$W, o2, 2);
                case "ddd":
                  return h2(n2.weekdaysShort, e2.$W, o2, 3);
                case "dddd":
                  return o2[e2.$W];
                case "H":
                  return String(s2);
                case "HH":
                  return b.s(s2, 2, "0");
                case "h":
                  return d2(1);
                case "hh":
                  return d2(2);
                case "a":
                  return $2(s2, u2, true);
                case "A":
                  return $2(s2, u2, false);
                case "m":
                  return String(u2);
                case "mm":
                  return b.s(u2, 2, "0");
                case "s":
                  return String(e2.$s);
                case "ss":
                  return b.s(e2.$s, 2, "0");
                case "SSS":
                  return b.s(e2.$ms, 3, "0");
                case "Z":
                  return i2;
              }
              return null;
            })(t3) || i2.replace(":", "");
          }));
        }, m2.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m2.diff = function(r2, d2, l2) {
          var $2, y2 = this, M3 = b.p(d2), m3 = O(r2), v2 = (m3.utcOffset() - this.utcOffset()) * e, g2 = this - m3, D2 = function() {
            return b.m(y2, m3);
          };
          switch (M3) {
            case h:
              $2 = D2() / 12;
              break;
            case c:
              $2 = D2();
              break;
            case f:
              $2 = D2() / 3;
              break;
            case o:
              $2 = (g2 - v2) / 6048e5;
              break;
            case a:
              $2 = (g2 - v2) / 864e5;
              break;
            case u:
              $2 = g2 / n;
              break;
            case s:
              $2 = g2 / e;
              break;
            case i:
              $2 = g2 / t;
              break;
            default:
              $2 = g2;
          }
          return l2 ? $2 : b.a($2);
        }, m2.daysInMonth = function() {
          return this.endOf(c).$D;
        }, m2.$locale = function() {
          return D[this.$L];
        }, m2.locale = function(t2, e2) {
          if (!t2) return this.$L;
          var n2 = this.clone(), r2 = w(t2, e2, true);
          return r2 && (n2.$L = r2), n2;
        }, m2.clone = function() {
          return b.w(this.$d, this);
        }, m2.toDate = function() {
          return new Date(this.valueOf());
        }, m2.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, m2.toISOString = function() {
          return this.$d.toISOString();
        }, m2.toString = function() {
          return this.$d.toUTCString();
        }, M2;
      })(), Y = _.prototype;
      return O.prototype = Y, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d]].forEach((function(t2) {
        Y[t2[1]] = function(e2) {
          return this.$g(e2, t2[0], t2[1]);
        };
      })), O.extend = function(t2, e2) {
        return t2.$i || (t2(e2, _, O), t2.$i = true), O;
      }, O.locale = w, O.isDayjs = S, O.unix = function(t2) {
        return O(1e3 * t2);
      }, O.en = D[g], O.Ls = D, O.p = {}, O;
    }));
  }
});

// ../../node_modules/.pnpm/dayjs@1.11.21/node_modules/dayjs/plugin/timezone.js
var require_timezone = __commonJS({
  "../../node_modules/.pnpm/dayjs@1.11.21/node_modules/dayjs/plugin/timezone.js"(exports, module) {
    !(function(t, e) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs_plugin_timezone = e();
    })(exports, (function() {
      "use strict";
      var t = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, e = {};
      return function(n, i, o) {
        var r, a = function(t2, n2, i2) {
          void 0 === i2 && (i2 = {});
          var o2 = new Date(t2), r2 = (function(t3, n3) {
            void 0 === n3 && (n3 = {});
            var i3 = n3.timeZoneName || "short", o3 = t3 + "|" + i3, r3 = e[o3];
            return r3 || (r3 = new Intl.DateTimeFormat("en-US", { hour12: false, timeZone: t3, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: i3 }), e[o3] = r3), r3;
          })(n2, i2);
          return r2.formatToParts(o2);
        }, u = function(e2, n2) {
          for (var i2 = a(e2, n2), r2 = [], u2 = 0; u2 < i2.length; u2 += 1) {
            var f2 = i2[u2], s2 = f2.type, m = f2.value, c = t[s2];
            c >= 0 && (r2[c] = parseInt(m, 10));
          }
          var d = r2[3], l = 24 === d ? 0 : d, h = r2[0] + "-" + r2[1] + "-" + r2[2] + " " + l + ":" + r2[4] + ":" + r2[5] + ":000", v = +e2;
          return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t2, e2) {
          void 0 === t2 && (t2 = r);
          var n2, i2 = this.utcOffset(), a2 = this.toDate(), u2 = a2.toLocaleString("en-US", { timeZone: t2 }), f2 = Math.round((a2 - new Date(u2)) / 1e3 / 60), s2 = 15 * -Math.round(a2.getTimezoneOffset() / 15) - f2;
          if (!Number(s2)) n2 = this.utcOffset(0, e2);
          else if (n2 = o(u2, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(s2, true), e2) {
            var m = n2.utcOffset();
            n2 = n2.add(i2 - m, "minute");
          }
          return n2.$x.$timezone = t2, n2;
        }, f.offsetName = function(t2) {
          var e2 = this.$x.$timezone || o.tz.guess(), n2 = a(this.valueOf(), e2, { timeZoneName: t2 }).find((function(t3) {
            return "timezonename" === t3.type.toLowerCase();
          }));
          return n2 && n2.value;
        };
        var s = f.startOf;
        f.startOf = function(t2, e2) {
          if (!this.$x || !this.$x.$timezone) return s.call(this, t2, e2);
          var n2 = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return s.call(n2, t2, e2).tz(this.$x.$timezone, true);
        }, o.tz = function(t2, e2, n2) {
          var i2 = n2 && e2, a2 = n2 || e2 || r, f2 = u(+o(), a2);
          if ("string" != typeof t2) return o(t2).tz(a2);
          var s2 = (function(t3, e3, n3) {
            var i3 = t3 - 60 * e3 * 1e3, o2 = u(i3, n3);
            if (e3 === o2) return [i3, e3];
            var r2 = u(i3 -= 60 * (o2 - e3) * 1e3, n3);
            return o2 === r2 ? [i3, o2] : [t3 - 60 * Math.min(o2, r2) * 1e3, Math.max(o2, r2)];
          })(o.utc(t2, i2).valueOf(), f2, a2), m = s2[0], c = s2[1], d = o(m).utcOffset(c);
          return d.$x.$timezone = a2, d;
        }, o.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t2) {
          r = t2;
        };
      };
    }));
  }
});

// ../../node_modules/.pnpm/dayjs@1.11.21/node_modules/dayjs/plugin/utc.js
var require_utc = __commonJS({
  "../../node_modules/.pnpm/dayjs@1.11.21/node_modules/dayjs/plugin/utc.js"(exports, module) {
    !(function(t, i) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = i() : "function" == typeof define && define.amd ? define(i) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs_plugin_utc = i();
    })(exports, (function() {
      "use strict";
      var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
      return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t2) {
          var i2 = { date: t2, utc: true, args: arguments };
          return new f(i2);
        }, u.utc = function(i2) {
          var e2 = n(this.toDate(), { locale: this.$L, utc: true });
          return i2 ? e2.add(this.utcOffset(), t) : e2;
        }, u.local = function() {
          return n(this.toDate(), { locale: this.$L, utc: false });
        };
        var r = u.parse;
        u.parse = function(t2) {
          t2.utc && (this.$u = true), this.$utils().u(t2.$offset) || (this.$offset = t2.$offset), r.call(this, t2);
        };
        var o = u.init;
        u.init = function() {
          if (this.$u) {
            var t2 = this.$d;
            this.$y = t2.getUTCFullYear(), this.$M = t2.getUTCMonth(), this.$D = t2.getUTCDate(), this.$W = t2.getUTCDay(), this.$H = t2.getUTCHours(), this.$m = t2.getUTCMinutes(), this.$s = t2.getUTCSeconds(), this.$ms = t2.getUTCMilliseconds();
          } else o.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s2, f2) {
          var n2 = this.$utils().u;
          if (n2(s2)) return this.$u ? 0 : n2(this.$offset) ? a.call(this) : this.$offset;
          if ("string" == typeof s2 && (s2 = (function(t2) {
            void 0 === t2 && (t2 = "");
            var s3 = t2.match(i);
            if (!s3) return null;
            var f3 = ("" + s3[0]).match(e) || ["-", 0, 0], n3 = f3[0], u3 = 60 * +f3[1] + +f3[2];
            return 0 === u3 ? 0 : "+" === n3 ? u3 : -u3;
          })(s2), null === s2)) return this;
          var u2 = Math.abs(s2) <= 16 ? 60 * s2 : s2;
          if (0 === u2) return this.utc(f2);
          var r2 = this.clone();
          if (f2) return r2.$offset = u2, r2.$u = false, r2;
          var o2 = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          return (r2 = this.local().add(u2 + o2, t)).$offset = u2, r2.$x.$localOffset = o2, r2;
        };
        var h = u.format;
        u.format = function(t2) {
          var i2 = t2 || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return h.call(this, i2);
        }, u.valueOf = function() {
          var t2 = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * t2;
        }, u.isUTC = function() {
          return !!this.$u;
        }, u.toISOString = function() {
          return this.toDate().toISOString();
        }, u.toString = function() {
          return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t2) {
          return "s" === t2 && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t2, i2, e2) {
          if (t2 && this.$u === t2.$u) return c.call(this, t2, i2, e2);
          var s2 = this.local(), f2 = n(t2).local();
          return c.call(s2, f2, i2, e2);
        };
      };
    }));
  }
});

// src/init.ts
import {
  init as coreInit,
  createFetchExecutor
} from "@hopdrive/sdk-core";
import {
  createFetchExecutor as createFetchExecutor2,
  resolveExecutor,
  resetDefaultExecutor,
  getLogger
} from "@hopdrive/sdk-core";
var initialized = false;
function init(config) {
  if (config.executor && config.executorConfig) {
    throw new Error('Provide either "executor" or "executorConfig", not both.');
  }
  if (!config.executor && !config.executorConfig) {
    throw new Error('Must provide either "executor" (pre-created) or "executorConfig" (to create one).');
  }
  const executor = config.executor ?? createFetchExecutor(config.executorConfig);
  coreInit({ executor, logger: config.logger });
  initialized = true;
}
function isInitialized() {
  return initialized;
}
function resetAppointmentsConfig() {
  initialized = false;
}

// src/constants/statuses.ts
var APPOINTMENT_STATUS = {
  NEW: "new",
  PENDING: "pending",
  READY: "ready",
  PAYING: "paying",
  PAID: "paid",
  FAILED: "failed",
  CANCELED: "canceled",
  REFUNDED: "refunded",
  COMPLETED: "completed",
  SHOWED: "showed",
  MISSED: "missed",
  DUPLICATE: "duplicate"
};
var STATUS_TRANSITIONS = {
  new: /* @__PURE__ */ new Set(["pending", "ready", "canceled"]),
  pending: /* @__PURE__ */ new Set(["ready", "canceled", "showed", "completed", "missed", "duplicate"]),
  ready: /* @__PURE__ */ new Set(["paying", "canceled", "completed", "showed", "missed", "duplicate"]),
  paying: /* @__PURE__ */ new Set(["paid", "failed"]),
  // `paid` is terminal-ish for consumer-pay: the appointment stays here through
  // the linked move's lifecycle by design (Caliber UI contract). Only refund/
  // cancel paths transition out. b2b/sparkserv flows never reach `paid`.
  paid: /* @__PURE__ */ new Set(["canceled", "refunded"]),
  failed: /* @__PURE__ */ new Set(["paying", "canceled"]),
  // Dealer-system mirror state: consumer arrived for service. From here the
  // dealer can mark the service done (completed) or correct earlier signals.
  showed: /* @__PURE__ */ new Set(["completed", "canceled", "missed", "duplicate"]),
  canceled: /* @__PURE__ */ new Set(),
  refunded: /* @__PURE__ */ new Set(),
  // `completed` is the b2b/sparkserv terminal — written atomically by
  // createValetMove when the move is linked, treating the appointment as
  // "done from our side". But a late Spark cancellation (consumer no-shows
  // or dealer cancels the order after we've already linked the move) must
  // still be able to cascade through to cancel the move. So `canceled` is
  // a legal forward edge from `completed`. Consumer-pay flows never reach
  // `completed`, so this only affects b2b appointments.
  completed: /* @__PURE__ */ new Set(["canceled"]),
  missed: /* @__PURE__ */ new Set(),
  duplicate: /* @__PURE__ */ new Set()
};
function isValidTransition(from, to) {
  return STATUS_TRANSITIONS[from].has(to);
}
function isTerminalStatus(status) {
  return STATUS_TRANSITIONS[status].size === 0;
}
function getValidTransitions(status) {
  return Array.from(STATUS_TRANSITIONS[status]);
}

// src/constants/types.ts
var APPOINTMENT_TYPE = {
  VALET: "valet",
  MOBILE_SERVICE: "mobile_service",
  WAITER: "waiter"
};
var KNOWN_APPOINTMENT_TYPES = [
  APPOINTMENT_TYPE.VALET,
  APPOINTMENT_TYPE.MOBILE_SERVICE,
  APPOINTMENT_TYPE.WAITER
];
function isKnownAppointmentType(value) {
  return KNOWN_APPOINTMENT_TYPES.includes(value);
}
var APPOINTMENT_SOURCE = {
  DEALER_PORTAL: "dealer_portal",
  SPARKSERV: "sparkserv",
  XTIME: "xtime",
  CDK: "cdk",
  API: "api"
};
var APPOINTMENT_PAYMENT_MODE = {
  CONSUMER_PAY: "consumer_pay",
  B2B: "b2b",
  SPLIT: "split",
  NONE: "none"
};
var CONSUMER_VEHICLE_DIRECTION = {
  TO_DEALER: "to_dealer",
  TO_CONSUMER: "to_consumer"
};
var KNOWN_CONSUMER_VEHICLE_DIRECTIONS = [
  CONSUMER_VEHICLE_DIRECTION.TO_DEALER,
  CONSUMER_VEHICLE_DIRECTION.TO_CONSUMER
];
function isKnownConsumerVehicleDirection(value) {
  return KNOWN_CONSUMER_VEHICLE_DIRECTIONS.includes(value);
}
var TYPES_REQUIRING_PICKUP_LOCATION = [
  APPOINTMENT_TYPE.VALET,
  APPOINTMENT_TYPE.MOBILE_SERVICE
];
var TYPES_REQUIRING_DELIVERY_LOCATION = [
  APPOINTMENT_TYPE.VALET
];

// src/constants/consumerPay.ts
var CONSUMER_PAY_ENABLED = false;
var CONSUMER_PAY_DISABLED_REASON = "Consumer-pay appointments are not available: HopDrive cannot price them yet, so none can be offered or paid for.";
function isConsumerPayRefused(paymentMode, enabled = CONSUMER_PAY_ENABLED) {
  return !enabled && paymentMode === APPOINTMENT_PAYMENT_MODE.CONSUMER_PAY;
}

// src/errors/index.ts
var InvalidStatusTransitionError = class extends Error {
  constructor(from, to) {
    const allowed = getValidTransitions(from);
    const allowedStr = allowed.length > 0 ? allowed.join(", ") : "none (terminal status)";
    super(
      `Invalid appointment status transition: ${from} \u2192 ${to}. Allowed transitions from ${from}: ${allowedStr}`
    );
    this.name = "InvalidStatusTransitionError";
    this.fromStatus = from;
    this.toStatus = to;
    this.allowedTransitions = allowed;
  }
};
var AppointmentValidationError = class extends Error {
  constructor(errors) {
    const errorList = Array.isArray(errors) ? errors : [errors];
    super(`Appointment validation failed: ${errorList.join("; ")}`);
    this.name = "AppointmentValidationError";
    this.validationErrors = errorList;
  }
};
var ImmutableFieldError = class extends Error {
  constructor(field) {
    super(
      `Field '${field}' cannot be changed after appointment creation. To change this value, create a new appointment.`
    );
    this.name = "ImmutableFieldError";
    this.field = field;
  }
};
var AppointmentNotFoundError = class extends Error {
  constructor(criteria) {
    const criteriaStr = Object.entries(criteria).map(([k, v]) => `${k}=${v}`).join(", ");
    super(`Appointment not found: ${criteriaStr}`);
    this.name = "AppointmentNotFoundError";
    this.criteria = criteria;
  }
};

// ../../gql/operations.ts
import { resolveExecutor as resolveExecutor2 } from "@hopdrive/sdk-core";

// ../../gql/schema.ts
var GetActiveDriversForAvailabilityDocument = { "__text": 'query GetActiveDriversForAvailability($customerId: bigint!) {\n  drivers(\n    where: {tax_class: {_eq: "lite"}, user: {users_usertocustomers: {customer_id: {_eq: $customerId}}}}\n  ) {\n    id\n    businesshours {\n      type\n      day_of_week\n      day\n      month\n      year\n      is_open\n      open_time\n      closed_time\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetActiveDriversForAvailability" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "drivers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "tax_class" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "lite", "block": false } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "user" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "users_usertocustomers" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }] } }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "businesshours" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "day_of_week" } }, { "kind": "Field", "name": { "kind": "Name", "value": "day" } }, { "kind": "Field", "name": { "kind": "Name", "value": "month" } }, { "kind": "Field", "name": { "kind": "Name", "value": "year" } }, { "kind": "Field", "name": { "kind": "Name", "value": "is_open" } }, { "kind": "Field", "name": { "kind": "Name", "value": "open_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "closed_time" } }] } }] } }] } }] };
var GetLocationBusinessHoursDocument = { "__text": 'query GetLocationBusinessHours($locationId: bigint!) {\n  businesshours(\n    where: {_or: [{location_id: {_eq: $locationId}}, {type: {_eq: "default-hours"}}, {type: {_eq: "customer-holiday"}}, {type: {_eq: "hopdrive-holiday"}}, {type: {_eq: "federal-holiday"}}]}\n  ) {\n    location_id\n    type\n    day_of_week\n    day\n    month\n    year\n    week_of_month\n    is_open\n    open_time\n    closed_time\n    name\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetLocationBusinessHours" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "locationId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "businesshours" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "location_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "locationId" } } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "default-hours", "block": false } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "customer-holiday", "block": false } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "hopdrive-holiday", "block": false } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "federal-holiday", "block": false } }] } }] }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "location_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "day_of_week" } }, { "kind": "Field", "name": { "kind": "Name", "value": "day" } }, { "kind": "Field", "name": { "kind": "Name", "value": "month" } }, { "kind": "Field", "name": { "kind": "Name", "value": "year" } }, { "kind": "Field", "name": { "kind": "Name", "value": "week_of_month" } }, { "kind": "Field", "name": { "kind": "Name", "value": "is_open" } }, { "kind": "Field", "name": { "kind": "Name", "value": "open_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "closed_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }] } }] } }] };
var GetLocationCoordinatesDocument = { "__text": "query GetLocationCoordinates($locationIds: [bigint!]!) {\n  locations(where: {id: {_in: $locationIds}}) {\n    id\n    latitude\n    longitude\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetLocationCoordinates" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "locationIds" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "locations" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "locationIds" } } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }] } }] } }] };
var GetRooftopAvailabilityInfoDocument = { "__text": "query GetRooftopAvailabilityInfo($customerId: bigint!) {\n  customers_by_pk(id: $customerId) {\n    id\n    tier\n    location {\n      id\n      timezone\n      latitude\n      longitude\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetRooftopAvailabilityInfo" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "customers_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tier" } }, { "kind": "Field", "name": { "kind": "Name", "value": "location" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "timezone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }] } }] } }] } }] };
var GetScenariosForAvailabilityDocument = { "__text": "query GetScenariosForAvailability($customerId: bigint!, $rangeStart: timestamptz!, $rangeEnd: timestamptz!) {\n  scenarios(\n    where: {moves: {move: {customer_id: {_eq: $customerId}, ready_by: {_gte: $rangeStart, _lt: $rangeEnd}}}}\n  ) {\n    id\n    scenario_key\n    moves {\n      move {\n        id\n        move_type\n        active\n        ready_by\n        pickup_started\n        driver_id\n        parent_move_id\n        delivery_time\n        config\n        lane {\n          duration_sec\n          pickup_inspection_sec\n          delivery_inspection_sec\n          return_ride_wait_sec\n          inverse {\n            duration_sec\n          }\n        }\n      }\n    }\n    bundletoscenarios {\n      bundle {\n        offers {\n          status\n          driver {\n            id\n          }\n        }\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetScenariosForAvailability" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "rangeStart" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "rangeEnd" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "scenarios" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "moves" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "move" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "ready_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "rangeStart" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_lt" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "rangeEnd" } } }] } }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "moves" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "move" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ready_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_started" } }, { "kind": "Field", "name": { "kind": "Name", "value": "driver_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "parent_move_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "lane" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "duration_sec" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_inspection_sec" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_inspection_sec" } }, { "kind": "Field", "name": { "kind": "Name", "value": "return_ride_wait_sec" } }, { "kind": "Field", "name": { "kind": "Name", "value": "inverse" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "duration_sec" } }] } }] } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "bundletoscenarios" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "bundle" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "offers" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "driver" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] } }] } }] } }] } }] };
var InsertAppointmentDocument = { "__text": "mutation InsertAppointment($customer_id: Int!, $status: String!, $type: String!, $source: String!, $external_id: String, $payment_mode: String, $consumer_name: String!, $consumer_phone: String, $consumer_email: String, $consumer_at_pickup: Boolean, $consumer_vehicle_direction: String, $pickup_location_id: Int, $delivery_location_id: Int, $appointment_time: timestamptz, $vehicle_vin: String, $vehicle_make: String, $vehicle_model: String, $vehicle_year: Int, $vehicle_color: String, $vehicle_trim: String, $vehicle_mileage: Int, $source_status: String, $source_dealership_id: String, $transport_type: String, $loaner_requested: Boolean, $ro_number: String, $webhook_received_at: timestamptz, $driver_notes: String, $config: jsonb, $workflow_set_id: Int, $accepted_terms: Boolean, $createdat: timestamptz!, $createdby: String, $updatedat: timestamptz!, $updatedby: String) {\n  insert_appointments_one(\n    object: {customer_id: $customer_id, status: $status, type: $type, source: $source, external_id: $external_id, payment_mode: $payment_mode, consumer_name: $consumer_name, consumer_phone: $consumer_phone, consumer_email: $consumer_email, consumer_at_pickup: $consumer_at_pickup, consumer_vehicle_direction: $consumer_vehicle_direction, pickup_location_id: $pickup_location_id, delivery_location_id: $delivery_location_id, appointment_time: $appointment_time, vehicle_vin: $vehicle_vin, vehicle_make: $vehicle_make, vehicle_model: $vehicle_model, vehicle_year: $vehicle_year, vehicle_color: $vehicle_color, vehicle_trim: $vehicle_trim, vehicle_mileage: $vehicle_mileage, source_status: $source_status, source_dealership_id: $source_dealership_id, transport_type: $transport_type, loaner_requested: $loaner_requested, ro_number: $ro_number, webhook_received_at: $webhook_received_at, driver_notes: $driver_notes, config: $config, workflow_set_id: $workflow_set_id, accepted_terms: $accepted_terms, createdat: $createdat, createdby: $createdby, updatedat: $updatedat, updatedby: $updatedby}\n  ) {\n    id\n    customer_id\n    status\n    type\n    source\n    external_id\n    payment_mode\n    scenario_id\n    consumer_name\n    consumer_phone\n    consumer_email\n    consumer_at_pickup\n    consumer_vehicle_direction\n    pickup_location_id\n    delivery_location_id\n    appointment_time\n    vehicle_vin\n    vehicle_make\n    vehicle_model\n    vehicle_year\n    vehicle_color\n    vehicle_trim\n    vehicle_mileage\n    source_status\n    source_dealership_id\n    transport_type\n    loaner_requested\n    ro_number\n    webhook_received_at\n    driver_notes\n    config\n    workflow_set_id\n    accepted_terms\n    createdat\n    createdby\n    updatedat\n    updatedby\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "InsertAppointment" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customer_id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "status" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "type" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "source" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "external_id" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "payment_mode" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "consumer_name" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "consumer_phone" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "consumer_email" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "consumer_at_pickup" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Boolean" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "consumer_vehicle_direction" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "pickup_location_id" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "delivery_location_id" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "appointment_time" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_vin" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_make" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_model" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_year" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_color" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_trim" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_mileage" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "source_status" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "source_dealership_id" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "transport_type" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "loaner_requested" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Boolean" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "ro_number" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "webhook_received_at" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "driver_notes" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "config" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "workflow_set_id" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "accepted_terms" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Boolean" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "createdat" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "createdby" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedat" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_appointments_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customer_id" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "status" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "type" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "type" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "source" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "source" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "external_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "external_id" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "payment_mode" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "payment_mode" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "consumer_name" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "consumer_name" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "consumer_phone" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "consumer_phone" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "consumer_email" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "consumer_email" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "consumer_at_pickup" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "consumer_at_pickup" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "consumer_vehicle_direction" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "consumer_vehicle_direction" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "pickup_location_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "pickup_location_id" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "delivery_location_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "delivery_location_id" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "appointment_time" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "appointment_time" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_vin" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_vin" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_make" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_make" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_model" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_model" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_year" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_year" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_color" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_color" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_trim" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_trim" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_mileage" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_mileage" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "source_status" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "source_status" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "source_dealership_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "source_dealership_id" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "transport_type" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "transport_type" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "loaner_requested" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "loaner_requested" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "ro_number" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "ro_number" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "webhook_received_at" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "webhook_received_at" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "driver_notes" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "driver_notes" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "config" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "config" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "workflow_set_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "workflow_set_id" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "accepted_terms" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "accepted_terms" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "createdat" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "createdat" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "createdby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "createdby" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedat" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source" } }, { "kind": "Field", "name": { "kind": "Name", "value": "external_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "payment_mode" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_email" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_at_pickup" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_vehicle_direction" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_location_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_location_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "appointment_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_vin" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_make" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_model" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_year" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_color" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_trim" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_mileage" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_dealership_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "transport_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "loaner_requested" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ro_number" } }, { "kind": "Field", "name": { "kind": "Name", "value": "webhook_received_at" } }, { "kind": "Field", "name": { "kind": "Name", "value": "driver_notes" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflow_set_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "accepted_terms" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdby" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedby" } }] } }] } }] };
var GetOrganizationRooftopsByCustomerIdDocument = { "__text": 'query GetOrganizationRooftopsByCustomerId($customerId: bigint!) {\n  customers(where: {id: {_eq: $customerId}}) {\n    id\n    organization {\n      id\n      name\n      customers {\n        id\n        name\n        address\n        location {\n          latitude\n          longitude\n        }\n        serviceable_radius_miles: config(path: "serviceable_radius_miles")\n        serviceable_radius_by_pickup: config(path: "serviceable_radius_by_pickup")\n        serviceable_radius_by_delivery: config(path: "serviceable_radius_by_delivery")\n        workflowsets {\n          id\n          name\n          description\n          type\n          active_contracts: contracts(\n            where: {begin_date: {_lte: "now()"}, _or: [{end_date: {_gte: "now()"}}, {end_date: {_is_null: true}}]}\n          ) {\n            begin_date\n            end_date\n            contract_rules {\n              raterules(where: {active: {_eq: "1"}}, order_by: {}) {\n                distance_start\n                distance_end\n                type\n                class_1_rate: rate\n                class_2_rate: rate\n                class_3_rate\n                class_4_rate\n                class_5_rate\n                class_6_rate\n                class_1_flat_rate: flat_rate\n                class_2_flat_rate: flat_rate\n                class_3_flat_rate\n                class_4_flat_rate\n                class_5_flat_rate\n                class_6_flat_rate\n                class\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetOrganizationRooftopsByCustomerId" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "customers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "organization" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customers" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "location" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "serviceable_radius_miles" }, "name": { "kind": "Name", "value": "config" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "path" }, "value": { "kind": "StringValue", "value": "serviceable_radius_miles", "block": false } }] }, { "kind": "Field", "alias": { "kind": "Name", "value": "serviceable_radius_by_pickup" }, "name": { "kind": "Name", "value": "config" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "path" }, "value": { "kind": "StringValue", "value": "serviceable_radius_by_pickup", "block": false } }] }, { "kind": "Field", "alias": { "kind": "Name", "value": "serviceable_radius_by_delivery" }, "name": { "kind": "Name", "value": "config" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "path" }, "value": { "kind": "StringValue", "value": "serviceable_radius_by_delivery", "block": false } }] }, { "kind": "Field", "name": { "kind": "Name", "value": "workflowsets" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "alias": { "kind": "Name", "value": "active_contracts" }, "name": { "kind": "Name", "value": "contracts" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "begin_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_lte" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "begin_date" } }, { "kind": "Field", "name": { "kind": "Name", "value": "end_date" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_rules" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "raterules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "1", "block": false } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "distance_start" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_end" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "alias": { "kind": "Name", "value": "class_1_rate" }, "name": { "kind": "Name", "value": "rate" } }, { "kind": "Field", "alias": { "kind": "Name", "value": "class_2_rate" }, "name": { "kind": "Name", "value": "rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_3_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_4_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_5_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_6_rate" } }, { "kind": "Field", "alias": { "kind": "Name", "value": "class_1_flat_rate" }, "name": { "kind": "Name", "value": "flat_rate" } }, { "kind": "Field", "alias": { "kind": "Name", "value": "class_2_flat_rate" }, "name": { "kind": "Name", "value": "flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_3_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_4_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_5_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_6_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class" } }] } }] } }] } }] } }] } }] } }] } }] } }] };
var GetOrganizationRooftopsByOrganizationIdDocument = { "__text": 'query GetOrganizationRooftopsByOrganizationId($organizationId: bigint!) {\n  customers(where: {organization_id: {_eq: $organizationId}}) {\n    id\n    organization {\n      id\n      name\n      customers {\n        id\n        name\n        address\n        location {\n          latitude\n          longitude\n        }\n        serviceable_radius_miles: config(path: "serviceable_radius_miles")\n        serviceable_radius_by_pickup: config(path: "serviceable_radius_by_pickup")\n        serviceable_radius_by_delivery: config(path: "serviceable_radius_by_delivery")\n        workflowsets {\n          id\n          name\n          description\n          type\n          active_contracts: contracts(\n            where: {begin_date: {_lte: "now()"}, _or: [{end_date: {_gte: "now()"}}, {end_date: {_is_null: true}}]}\n          ) {\n            begin_date\n            end_date\n            contract_rules {\n              raterules(where: {active: {_eq: "1"}}, order_by: {}) {\n                distance_start\n                distance_end\n                type\n                class_1_rate: rate\n                class_2_rate: rate\n                class_3_rate\n                class_4_rate\n                class_5_rate\n                class_6_rate\n                class_1_flat_rate: flat_rate\n                class_2_flat_rate: flat_rate\n                class_3_flat_rate\n                class_4_flat_rate\n                class_5_flat_rate\n                class_6_flat_rate\n                class\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetOrganizationRooftopsByOrganizationId" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "organizationId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "customers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "organization_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "organizationId" } } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "organization" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customers" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "location" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "serviceable_radius_miles" }, "name": { "kind": "Name", "value": "config" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "path" }, "value": { "kind": "StringValue", "value": "serviceable_radius_miles", "block": false } }] }, { "kind": "Field", "alias": { "kind": "Name", "value": "serviceable_radius_by_pickup" }, "name": { "kind": "Name", "value": "config" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "path" }, "value": { "kind": "StringValue", "value": "serviceable_radius_by_pickup", "block": false } }] }, { "kind": "Field", "alias": { "kind": "Name", "value": "serviceable_radius_by_delivery" }, "name": { "kind": "Name", "value": "config" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "path" }, "value": { "kind": "StringValue", "value": "serviceable_radius_by_delivery", "block": false } }] }, { "kind": "Field", "name": { "kind": "Name", "value": "workflowsets" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "alias": { "kind": "Name", "value": "active_contracts" }, "name": { "kind": "Name", "value": "contracts" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "begin_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_lte" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "begin_date" } }, { "kind": "Field", "name": { "kind": "Name", "value": "end_date" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_rules" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "raterules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "1", "block": false } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "distance_start" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_end" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "alias": { "kind": "Name", "value": "class_1_rate" }, "name": { "kind": "Name", "value": "rate" } }, { "kind": "Field", "alias": { "kind": "Name", "value": "class_2_rate" }, "name": { "kind": "Name", "value": "rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_3_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_4_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_5_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_6_rate" } }, { "kind": "Field", "alias": { "kind": "Name", "value": "class_1_flat_rate" }, "name": { "kind": "Name", "value": "flat_rate" } }, { "kind": "Field", "alias": { "kind": "Name", "value": "class_2_flat_rate" }, "name": { "kind": "Name", "value": "flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_3_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_4_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_5_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_6_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class" } }] } }] } }] } }] } }] } }] } }] } }] } }] };
var LinkScenarioDocument = { "__text": "mutation LinkScenario($id: bigint!, $scenario_id: Int!, $updatedat: timestamptz!, $updatedby: String) {\n  update_appointments_by_pk(\n    pk_columns: {id: $id}\n    _set: {scenario_id: $scenario_id, updatedat: $updatedat, updatedby: $updatedby}\n  ) {\n    id\n    customer_id\n    status\n    type\n    source\n    external_id\n    payment_mode\n    scenario_id\n    consumer_name\n    consumer_phone\n    consumer_email\n    consumer_at_pickup\n    consumer_vehicle_direction\n    pickup_location_id\n    delivery_location_id\n    appointment_time\n    vehicle_vin\n    vehicle_make\n    vehicle_model\n    vehicle_year\n    vehicle_color\n    vehicle_trim\n    vehicle_mileage\n    source_status\n    source_dealership_id\n    transport_type\n    loaner_requested\n    ro_number\n    webhook_received_at\n    driver_notes\n    config\n    workflow_set_id\n    accepted_terms\n    createdat\n    createdby\n    updatedat\n    updatedby\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "LinkScenario" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "scenario_id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedat" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_appointments_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "scenario_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenario_id" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedat" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source" } }, { "kind": "Field", "name": { "kind": "Name", "value": "external_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "payment_mode" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_email" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_at_pickup" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_vehicle_direction" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_location_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_location_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "appointment_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_vin" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_make" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_model" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_year" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_color" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_trim" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_mileage" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_dealership_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "transport_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "loaner_requested" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ro_number" } }, { "kind": "Field", "name": { "kind": "Name", "value": "webhook_received_at" } }, { "kind": "Field", "name": { "kind": "Name", "value": "driver_notes" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflow_set_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "accepted_terms" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdby" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedby" } }] } }] } }] };
var GetAppointmentDocument = { "__text": "query GetAppointment($id: bigint!) {\n  appointments_by_pk(id: $id) {\n    id\n    customer_id\n    status\n    type\n    source\n    external_id\n    payment_mode\n    scenario_id\n    consumer_name\n    consumer_phone\n    consumer_email\n    consumer_at_pickup\n    consumer_vehicle_direction\n    pickup_location_id\n    delivery_location_id\n    appointment_time\n    vehicle_vin\n    vehicle_make\n    vehicle_model\n    vehicle_year\n    vehicle_color\n    vehicle_trim\n    vehicle_mileage\n    source_status\n    source_dealership_id\n    transport_type\n    loaner_requested\n    ro_number\n    webhook_received_at\n    driver_notes\n    config\n    workflow_set_id\n    accepted_terms\n    createdat\n    createdby\n    updatedat\n    updatedby\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetAppointment" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "appointments_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source" } }, { "kind": "Field", "name": { "kind": "Name", "value": "external_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "payment_mode" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_email" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_at_pickup" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_vehicle_direction" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_location_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_location_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "appointment_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_vin" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_make" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_model" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_year" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_color" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_trim" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_mileage" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_dealership_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "transport_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "loaner_requested" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ro_number" } }, { "kind": "Field", "name": { "kind": "Name", "value": "webhook_received_at" } }, { "kind": "Field", "name": { "kind": "Name", "value": "driver_notes" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflow_set_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "accepted_terms" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdby" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedby" } }] } }] } }] };
var GetAppointmentByExternalIdDocument = { "__text": "query GetAppointmentByExternalId($source: String!, $external_id: String!) {\n  appointments(\n    where: {source: {_eq: $source}, external_id: {_eq: $external_id}}\n    limit: 1\n  ) {\n    id\n    customer_id\n    status\n    type\n    source\n    external_id\n    payment_mode\n    scenario_id\n    consumer_name\n    consumer_phone\n    consumer_email\n    consumer_at_pickup\n    consumer_vehicle_direction\n    pickup_location_id\n    delivery_location_id\n    appointment_time\n    vehicle_vin\n    vehicle_make\n    vehicle_model\n    vehicle_year\n    vehicle_color\n    vehicle_trim\n    vehicle_mileage\n    source_status\n    source_dealership_id\n    transport_type\n    loaner_requested\n    ro_number\n    webhook_received_at\n    driver_notes\n    config\n    workflow_set_id\n    accepted_terms\n    createdat\n    createdby\n    updatedat\n    updatedby\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetAppointmentByExternalId" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "source" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "external_id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "appointments" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "source" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "source" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "external_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "external_id" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source" } }, { "kind": "Field", "name": { "kind": "Name", "value": "external_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "payment_mode" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_email" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_at_pickup" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_vehicle_direction" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_location_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_location_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "appointment_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_vin" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_make" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_model" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_year" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_color" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_trim" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_mileage" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_dealership_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "transport_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "loaner_requested" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ro_number" } }, { "kind": "Field", "name": { "kind": "Name", "value": "webhook_received_at" } }, { "kind": "Field", "name": { "kind": "Name", "value": "driver_notes" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflow_set_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "accepted_terms" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdby" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedby" } }] } }] } }] };
var GetAppointmentStatusDocument = { "__text": "query GetAppointmentStatus($id: bigint!) {\n  appointments_by_pk(id: $id) {\n    id\n    status\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetAppointmentStatus" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "appointments_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }] };
var UpdateAppointmentDocument = { "__text": "mutation UpdateAppointment($id: bigint!, $changes: appointments_set_input!) {\n  update_appointments_by_pk(pk_columns: {id: $id}, _set: $changes) {\n    id\n    customer_id\n    status\n    type\n    source\n    external_id\n    payment_mode\n    scenario_id\n    consumer_name\n    consumer_phone\n    consumer_email\n    consumer_at_pickup\n    consumer_vehicle_direction\n    pickup_location_id\n    delivery_location_id\n    appointment_time\n    vehicle_vin\n    vehicle_make\n    vehicle_model\n    vehicle_year\n    vehicle_color\n    vehicle_trim\n    vehicle_mileage\n    source_status\n    source_dealership_id\n    transport_type\n    loaner_requested\n    ro_number\n    webhook_received_at\n    driver_notes\n    config\n    workflow_set_id\n    accepted_terms\n    createdat\n    createdby\n    updatedat\n    updatedby\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "UpdateAppointment" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "changes" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "appointments_set_input" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_appointments_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "changes" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source" } }, { "kind": "Field", "name": { "kind": "Name", "value": "external_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "payment_mode" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_email" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_at_pickup" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_vehicle_direction" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_location_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_location_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "appointment_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_vin" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_make" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_model" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_year" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_color" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_trim" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_mileage" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_dealership_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "transport_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "loaner_requested" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ro_number" } }, { "kind": "Field", "name": { "kind": "Name", "value": "webhook_received_at" } }, { "kind": "Field", "name": { "kind": "Name", "value": "driver_notes" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflow_set_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "accepted_terms" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdby" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedby" } }] } }] } }] };
var UpdateAppointmentStatusDocument = { "__text": "mutation UpdateAppointmentStatus($id: bigint!, $status: String!, $updatedat: timestamptz!, $updatedby: String) {\n  update_appointments_by_pk(\n    pk_columns: {id: $id}\n    _set: {status: $status, updatedat: $updatedat, updatedby: $updatedby}\n  ) {\n    id\n    customer_id\n    status\n    type\n    source\n    external_id\n    payment_mode\n    scenario_id\n    consumer_name\n    consumer_phone\n    consumer_email\n    consumer_at_pickup\n    consumer_vehicle_direction\n    pickup_location_id\n    delivery_location_id\n    appointment_time\n    vehicle_vin\n    vehicle_make\n    vehicle_model\n    vehicle_year\n    vehicle_color\n    vehicle_trim\n    vehicle_mileage\n    source_status\n    source_dealership_id\n    transport_type\n    loaner_requested\n    ro_number\n    webhook_received_at\n    driver_notes\n    config\n    workflow_set_id\n    accepted_terms\n    createdat\n    createdby\n    updatedat\n    updatedby\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "UpdateAppointmentStatus" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "status" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedat" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_appointments_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "status" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedat" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source" } }, { "kind": "Field", "name": { "kind": "Name", "value": "external_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "payment_mode" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_email" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_at_pickup" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_vehicle_direction" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_location_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_location_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "appointment_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_vin" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_make" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_model" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_year" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_color" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_trim" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_mileage" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_dealership_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "transport_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "loaner_requested" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ro_number" } }, { "kind": "Field", "name": { "kind": "Name", "value": "webhook_received_at" } }, { "kind": "Field", "name": { "kind": "Name", "value": "driver_notes" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflow_set_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "accepted_terms" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdby" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedby" } }] } }] } }] };

// ../../gql/operations.ts
async function getActiveDriversForAvailability(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor2(executor).query(
    GetActiveDriversForAvailabilityDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.drivers;
}
async function getAppointment(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor2(executor).query(
    GetAppointmentDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.appointments_by_pk;
}
async function getAppointmentByExternalId(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor2(executor).query(
    GetAppointmentByExternalIdDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.appointments;
}
async function getAppointmentStatus(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor2(executor).query(
    GetAppointmentStatusDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.appointments_by_pk;
}
async function getLocationBusinessHours(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor2(executor).query(
    GetLocationBusinessHoursDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.businesshours;
}
async function getLocationCoordinates(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor2(executor).query(
    GetLocationCoordinatesDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.locations;
}
async function getOrganizationRooftopsByCustomerId(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor2(executor).query(
    GetOrganizationRooftopsByCustomerIdDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.customers;
}
async function getOrganizationRooftopsByOrganizationId(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor2(executor).query(
    GetOrganizationRooftopsByOrganizationIdDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.customers;
}
async function getRooftopAvailabilityInfo(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor2(executor).query(
    GetRooftopAvailabilityInfoDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.customers_by_pk;
}
async function getScenariosForAvailability(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor2(executor).query(
    GetScenariosForAvailabilityDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.scenarios;
}
async function insertAppointment(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor2(executor).mutate(
    InsertAppointmentDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.insert_appointments_one;
}
async function linkScenario(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor2(executor).mutate(
    LinkScenarioDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.update_appointments_by_pk;
}
async function updateAppointment(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor2(executor).mutate(
    UpdateAppointmentDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.update_appointments_by_pk;
}
async function updateAppointmentStatus(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor2(executor).mutate(
    UpdateAppointmentStatusDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.update_appointments_by_pk;
}

// src/features/validate/validateAppointment.ts
var PHONE_PATTERN = /^\+?[\d\s\-().]{7,20}$/;
var VIN_PATTERN = /^[A-HJ-NPR-Z0-9]{17}$/i;
var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
function isValidVinCheckDigit(vin) {
  const upper = vin.toUpperCase();
  const transliteration = {
    A: 1,
    B: 2,
    C: 3,
    D: 4,
    E: 5,
    F: 6,
    G: 7,
    H: 8,
    J: 1,
    K: 2,
    L: 3,
    M: 4,
    N: 5,
    P: 7,
    R: 9,
    S: 2,
    T: 3,
    U: 4,
    V: 5,
    W: 6,
    X: 7,
    Y: 8,
    Z: 9
  };
  const positionWeights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
  let sum = 0;
  for (let i = 0; i < 17; i++) {
    const char = upper[i];
    const value = /\d/.test(char) ? parseInt(char, 10) : transliteration[char] ?? 0;
    sum += value * positionWeights[i];
  }
  const remainder = sum % 11;
  const checkDigit = upper[8];
  const expected = remainder === 10 ? "X" : String(remainder);
  return checkDigit === expected;
}
function validateCreateInput(input) {
  const errors = [];
  if (!input.customerId || typeof input.customerId !== "number") {
    errors.push("customerId is required and must be a number");
  }
  if (!input.type || typeof input.type !== "string") {
    errors.push("type is required");
  } else if (!isKnownAppointmentType(input.type)) {
    errors.push(
      `type '${input.type}' is not a known appointment type. Known types: valet, mobile_service, waiter`
    );
  }
  if (!input.source || typeof input.source !== "string") {
    errors.push("source is required");
  }
  if (!input.consumerName || typeof input.consumerName !== "string" || !input.consumerName.trim()) {
    errors.push("consumerName is required and must be a non-empty string");
  }
  if (input.consumerPhone && input.consumerPhone.trim()) {
    if (!PHONE_PATTERN.test(input.consumerPhone.trim())) {
      errors.push(`consumerPhone '${input.consumerPhone}' is not a valid phone number`);
    }
  }
  if (input.vehicle?.vin && input.vehicle.vin.trim()) {
    const vin = input.vehicle.vin.trim();
    if (!VIN_PATTERN.test(vin)) {
      errors.push(
        `vehicle.vin '${vin}' is not a valid VIN \u2014 must be 17 alphanumeric characters (excluding I, O, Q)`
      );
    } else if (!isValidVinCheckDigit(vin)) {
      errors.push(`vehicle.vin '${vin}' has an invalid check digit`);
    }
  }
  if (input.consumerEmail && input.consumerEmail.trim()) {
    if (!EMAIL_PATTERN.test(input.consumerEmail.trim())) {
      errors.push(`consumerEmail '${input.consumerEmail}' is not a valid email address`);
    }
  }
  if (input.consumerVehicleDirection && typeof input.consumerVehicleDirection === "string") {
    if (!isKnownConsumerVehicleDirection(input.consumerVehicleDirection)) {
      errors.push(
        `consumerVehicleDirection '${input.consumerVehicleDirection}' is not a known direction. Known directions: to_dealer, to_consumer`
      );
    }
  }
  if (input.vehicle?.mileage !== void 0 && input.vehicle?.mileage !== null && (typeof input.vehicle.mileage !== "number" || input.vehicle.mileage < 0)) {
    errors.push(`vehicle.mileage must be a non-negative number if provided`);
  }
  if (errors.length > 0) {
    throw new AppointmentValidationError(errors);
  }
}
function validateUpdateChanges(changes) {
  const errors = [];
  if ("consumerName" in changes) {
    if (!changes.consumerName || typeof changes.consumerName !== "string" || !changes.consumerName.trim()) {
      errors.push("consumerName must be a non-empty string if provided");
    }
  }
  if ("consumerPhone" in changes && changes.consumerPhone && changes.consumerPhone.trim()) {
    if (!PHONE_PATTERN.test(changes.consumerPhone.trim())) {
      errors.push(`consumerPhone '${changes.consumerPhone}' is not a valid phone number`);
    }
  }
  if (changes.vehicle?.vin && changes.vehicle.vin.trim()) {
    const vin = changes.vehicle.vin.trim();
    if (!VIN_PATTERN.test(vin)) {
      errors.push(
        `vehicle.vin '${vin}' is not a valid VIN \u2014 must be 17 alphanumeric characters (excluding I, O, Q)`
      );
    } else if (!isValidVinCheckDigit(vin)) {
      errors.push(`vehicle.vin '${vin}' has an invalid check digit`);
    }
  }
  if ("consumerEmail" in changes && changes.consumerEmail && changes.consumerEmail.trim()) {
    if (!EMAIL_PATTERN.test(changes.consumerEmail.trim())) {
      errors.push(`consumerEmail '${changes.consumerEmail}' is not a valid email address`);
    }
  }
  if ("consumerVehicleDirection" in changes && changes.consumerVehicleDirection && typeof changes.consumerVehicleDirection === "string") {
    if (!isKnownConsumerVehicleDirection(changes.consumerVehicleDirection)) {
      errors.push(
        `consumerVehicleDirection '${changes.consumerVehicleDirection}' is not a known direction. Known directions: to_dealer, to_consumer`
      );
    }
  }
  if (changes.vehicle?.mileage !== void 0 && changes.vehicle?.mileage !== null && (typeof changes.vehicle.mileage !== "number" || changes.vehicle.mileage < 0)) {
    errors.push(`vehicle.mileage must be a non-negative number if provided`);
  }
  if (errors.length > 0) {
    throw new AppointmentValidationError(errors);
  }
}
function validateAppointment(input) {
  try {
    validateCreateInput(input);
    return [];
  } catch (err) {
    if (err instanceof AppointmentValidationError) {
      return err.validationErrors;
    }
    throw err;
  }
}

// src/features/create/createAppointment.ts
function resolveConsumerAtPickup(params) {
  if (typeof params.consumerAtPickup === "boolean") return params.consumerAtPickup;
  return params.consumerVehicleDirection === "to_consumer" ? false : true;
}
async function createAppointment(params) {
  validateCreateInput(params);
  const now = (/* @__PURE__ */ new Date()).toISOString();
  const result = await insertAppointment(
    {
      customer_id: params.customerId,
      status: params.status ?? APPOINTMENT_STATUS.NEW,
      type: params.type,
      source: params.source,
      external_id: params.externalId ?? null,
      payment_mode: params.paymentMode ?? null,
      consumer_name: params.consumerName.trim(),
      consumer_phone: params.consumerPhone?.trim() ?? null,
      consumer_email: params.consumerEmail?.trim() ?? null,
      consumer_at_pickup: resolveConsumerAtPickup(params),
      consumer_vehicle_direction: params.consumerVehicleDirection ?? null,
      pickup_location_id: params.pickupLocationId ?? null,
      delivery_location_id: params.deliveryLocationId ?? null,
      appointment_time: params.appointmentTime ?? null,
      vehicle_vin: params.vehicle?.vin?.trim() ?? null,
      vehicle_make: params.vehicle?.make?.trim() ?? null,
      vehicle_model: params.vehicle?.model?.trim() ?? null,
      vehicle_year: params.vehicle?.year ?? null,
      vehicle_color: params.vehicle?.color?.trim() ?? null,
      vehicle_trim: params.vehicle?.trim?.trim() ?? null,
      vehicle_mileage: params.vehicle?.mileage ?? null,
      source_status: params.sourceStatus ?? null,
      source_dealership_id: params.sourceDealershipId ?? null,
      transport_type: params.transportType ?? null,
      loaner_requested: params.loanerRequested ?? null,
      ro_number: params.roNumber ?? null,
      webhook_received_at: params.webhookReceivedAt ?? null,
      driver_notes: params.driverNotes?.trim() ?? null,
      config: params.config ?? null,
      workflow_set_id: params.workflowSetId ?? 1,
      accepted_terms: false,
      createdat: now,
      createdby: params.createdBy ?? null,
      updatedat: now,
      updatedby: params.createdBy ?? null
    },
    { executor: params.executor }
  );
  return result;
}

// src/features/update/updateAppointment.ts
var IMMUTABLE_FIELDS = ["customerId", "source", "customer_id"];
async function updateAppointment2(params) {
  const changesAsRecord = params.changes;
  for (const field of IMMUTABLE_FIELDS) {
    if (field in changesAsRecord) {
      throw new ImmutableFieldError(field);
    }
  }
  validateUpdateChanges(params.changes);
  const now = (/* @__PURE__ */ new Date()).toISOString();
  const { changes } = params;
  const setInput = {
    updatedat: now,
    updatedby: params.updatedBy ?? null
  };
  if ("type" in changes) setInput.type = changes.type ?? null;
  if ("consumerName" in changes) setInput.consumer_name = changes.consumerName?.trim() ?? null;
  if ("consumerPhone" in changes) setInput.consumer_phone = changes.consumerPhone?.trim() ?? null;
  if ("consumerEmail" in changes) setInput.consumer_email = changes.consumerEmail?.trim() ?? null;
  if ("consumerAtPickup" in changes) setInput.consumer_at_pickup = changes.consumerAtPickup ?? null;
  if ("consumerVehicleDirection" in changes) setInput.consumer_vehicle_direction = changes.consumerVehicleDirection ?? null;
  if ("pickupLocationId" in changes) setInput.pickup_location_id = changes.pickupLocationId ?? null;
  if ("deliveryLocationId" in changes) setInput.delivery_location_id = changes.deliveryLocationId ?? null;
  if ("appointmentTime" in changes) setInput.appointment_time = changes.appointmentTime ?? null;
  if ("sourceStatus" in changes) setInput.source_status = changes.sourceStatus ?? null;
  if ("sourceDealershipId" in changes) setInput.source_dealership_id = changes.sourceDealershipId ?? null;
  if ("transportType" in changes) setInput.transport_type = changes.transportType ?? null;
  if ("loanerRequested" in changes) setInput.loaner_requested = changes.loanerRequested ?? null;
  if ("roNumber" in changes) setInput.ro_number = changes.roNumber ?? null;
  if ("webhookReceivedAt" in changes) setInput.webhook_received_at = changes.webhookReceivedAt ?? null;
  if ("driverNotes" in changes) setInput.driver_notes = changes.driverNotes?.trim() ?? null;
  if ("externalId" in changes) setInput.external_id = changes.externalId ?? null;
  if ("paymentMode" in changes) setInput.payment_mode = changes.paymentMode ?? null;
  if ("config" in changes) setInput.config = changes.config ?? null;
  if ("workflowSetId" in changes) setInput.workflow_set_id = changes.workflowSetId ?? null;
  if ("vehicle" in changes && changes.vehicle !== void 0) {
    const v = changes.vehicle;
    if (v === null) {
      setInput.vehicle_vin = null;
      setInput.vehicle_make = null;
      setInput.vehicle_model = null;
      setInput.vehicle_year = null;
      setInput.vehicle_color = null;
      setInput.vehicle_trim = null;
      setInput.vehicle_mileage = null;
    } else {
      if ("vin" in v) setInput.vehicle_vin = v.vin?.trim() ?? null;
      if ("make" in v) setInput.vehicle_make = v.make?.trim() ?? null;
      if ("model" in v) setInput.vehicle_model = v.model?.trim() ?? null;
      if ("year" in v) setInput.vehicle_year = v.year ?? null;
      if ("color" in v) setInput.vehicle_color = v.color?.trim() ?? null;
      if ("trim" in v) setInput.vehicle_trim = v.trim?.trim() ?? null;
      if ("mileage" in v) setInput.vehicle_mileage = v.mileage ?? null;
    }
  }
  const variables = {
    id: params.appointmentId,
    changes: setInput
  };
  const result = await updateAppointment(variables, { executor: params.executor });
  return result;
}

// src/features/update/updateStatus.ts
async function updateStatus(params) {
  const currentAppointment = await getAppointmentStatus(
    { id: params.appointmentId },
    { executor: params.executor }
  );
  if (!currentAppointment) {
    throw new AppointmentNotFoundError({ id: params.appointmentId });
  }
  const fromStatus = currentAppointment.status;
  const toStatus = params.status;
  if (!isValidTransition(fromStatus, toStatus)) {
    throw new InvalidStatusTransitionError(fromStatus, toStatus);
  }
  const now = (/* @__PURE__ */ new Date()).toISOString();
  const result = await updateAppointmentStatus(
    {
      id: params.appointmentId,
      status: toStatus,
      updatedat: now,
      updatedby: params.updatedBy ?? null
    },
    { executor: params.executor }
  );
  return result;
}

// src/features/link/linkScenario.ts
async function linkScenario2(params) {
  const now = (/* @__PURE__ */ new Date()).toISOString();
  const result = await linkScenario(
    {
      id: params.appointmentId,
      scenario_id: params.scenarioId,
      updatedat: now,
      updatedby: params.updatedBy ?? null
    },
    { executor: params.executor }
  );
  if (!result) {
    throw new AppointmentNotFoundError({ id: params.appointmentId });
  }
  return result;
}

// src/features/query/getAppointment.ts
async function getAppointment2(params) {
  const result = await getAppointment({ id: params.appointmentId }, { executor: params.executor });
  return result;
}
async function getAppointmentByExternalId2(params) {
  const result = await getAppointmentByExternalId(
    { source: params.source, external_id: params.externalId },
    { executor: params.executor }
  );
  return result[0] ?? null;
}
async function getAppointmentOrThrow(params) {
  const appointment = await getAppointment2(params);
  if (!appointment) {
    throw new AppointmentNotFoundError({ id: params.appointmentId });
  }
  return appointment;
}

// src/features/config/parseAppointmentConfig.ts
var DEFAULTS = {
  enabled: false,
  strategy: "balance-drivers-v1",
  driverCount: 2,
  moveBufferMinutes: 0,
  fullPlanningEnabled: false,
  enforcementMode: "suggestion",
  offsetIncrementMinutes: 0,
  offsetMaxMinutes: 0
};
function parseAppointmentConfig(input) {
  if (!input) {
    return { appointment_management: { ...DEFAULTS } };
  }
  return {
    appointment_management: {
      enabled: input.enabled === true,
      strategy: input.strategy ?? DEFAULTS.strategy,
      driverCount: input.driver_count ?? DEFAULTS.driverCount,
      moveBufferMinutes: input.move_buffer_minutes ?? DEFAULTS.moveBufferMinutes,
      fullPlanningEnabled: input.full_planning_enabled === true,
      enforcementMode: input.enforcement_mode ?? DEFAULTS.enforcementMode,
      offsetIncrementMinutes: input.offset_increment_minutes ?? DEFAULTS.offsetIncrementMinutes,
      offsetMaxMinutes: input.offset_max_minutes ?? DEFAULTS.offsetMaxMinutes
    }
  };
}

// src/features/scenarios/scenarioPredicates.ts
var ScenarioKey = {
  CONCIERGE_PICKUP: "concierge-pu",
  CONCIERGE_PICKUP_NO_RIDESHARE: "concierge-pu-no-rideshare",
  CONCIERGE_RETURN: "concierge-ret",
  CONCIERGE_RETURN_NO_RIDESHARE: "concierge-ret-no-rideshare",
  CONCIERGE_LOANER_PICKUP: "concierge-loaner-pu",
  CONCIERGE_LOANER_RETURN: "concierge-loaner-ret"
};
function isConciergePickupScenario(key) {
  return key === ScenarioKey.CONCIERGE_PICKUP || key === ScenarioKey.CONCIERGE_PICKUP_NO_RIDESHARE;
}
function isConciergeReturnScenario(key) {
  return key === ScenarioKey.CONCIERGE_RETURN || key === ScenarioKey.CONCIERGE_RETURN_NO_RIDESHARE;
}
function isConciergeScenario(key) {
  return isConciergePickupScenario(key) || isConciergeReturnScenario(key);
}
function isConciergeLoanerScenario(key) {
  return key === ScenarioKey.CONCIERGE_LOANER_PICKUP || key === ScenarioKey.CONCIERGE_LOANER_RETURN;
}
function isAnyConciergeScenario(key) {
  return isConciergeScenario(key) || isConciergeLoanerScenario(key);
}
function hasRideMove(scenario) {
  if (!scenario?.moves) return false;
  return scenario.moves.some((link) => {
    const move = link?.move;
    return move?.move_type === "ride" && move?.active !== 0;
  });
}

// src/utils/dayjs.ts
var import_dayjs = __toESM(require_dayjs_min());
var import_timezone = __toESM(require_timezone());
var import_utc = __toESM(require_utc());
import_dayjs.default.extend(import_utc.default);
import_dayjs.default.extend(import_timezone.default);

// src/features/business-hours/resolveBusinessHours.ts
var DEFAULT_OPEN_TIME = "06:00:00";
var DEFAULT_CLOSE_TIME = "20:00:00";
function anchorDate(date, timezoneStr) {
  return (0, import_dayjs.default)(date).add(12, "hours").tz(timezoneStr);
}
function matchesOneOffClosure(row, day, month, year) {
  return row.type === "one-off" && row.day === day && row.month === month && row.year === year && row.is_open === false;
}
function matchesHolidayPattern(row, anchor, month, dayOfWeek) {
  if (row.type !== "customer-holiday" && row.type !== "hopdrive-holiday" && row.type !== "federal-holiday") {
    return false;
  }
  if (row.month !== month) return false;
  if (row.day_of_week !== dayOfWeek) return false;
  const firstDayOfMonth = anchor.startOf("month");
  const firstOccurrence = firstDayOfMonth.day(dayOfWeek);
  const adjustedFirstOccurrence = firstOccurrence.month() !== firstDayOfMonth.month() ? firstOccurrence.add(1, "week") : firstOccurrence;
  const targetWeekDate = adjustedFirstOccurrence.add((row.week_of_month || 1) - 1, "week");
  return targetWeekDate.isSame(anchor, "day");
}
function pickSortedRange(rows) {
  const opens = rows.map((r) => r.open_time).filter((t) => typeof t === "string" && t.length > 0).sort();
  const closes = rows.map((r) => r.closed_time).filter((t) => typeof t === "string" && t.length > 0).sort();
  if (opens.length === 0 || closes.length === 0) return null;
  return { open: opens[0], close: closes[closes.length - 1] };
}
function defaults() {
  return {
    openTime: DEFAULT_OPEN_TIME,
    closeTime: DEFAULT_CLOSE_TIME,
    isClosed: false,
    isUsingDefaults: true
  };
}
function resolveBusinessHours(rows, locationId, date, timezoneStr, tier) {
  if (!locationId || rows == null) {
    return defaults();
  }
  const locationIdStr = String(locationId);
  const allRows = [...rows];
  const anchor = anchorDate(date, timezoneStr);
  const day = anchor.date();
  const month = anchor.month() + 1;
  const year = anchor.year();
  const dayOfWeek = anchor.day();
  for (const row of allRows) {
    if (matchesOneOffClosure(row, day, month, year)) {
      return {
        openTime: DEFAULT_OPEN_TIME,
        closeTime: DEFAULT_CLOSE_TIME,
        isClosed: true,
        closureName: row.name || "Closed",
        isUsingDefaults: false
      };
    }
    if (matchesHolidayPattern(row, anchor, month, dayOfWeek)) {
      return {
        openTime: DEFAULT_OPEN_TIME,
        closeTime: DEFAULT_CLOSE_TIME,
        isClosed: true,
        closureName: row.name || "Holiday",
        isUsingDefaults: false
      };
    }
  }
  const oneOffModified = allRows.filter(
    (r) => String(r.location_id ?? "") === locationIdStr && r.type === "one-off" && r.day === day && r.month === month && r.year === year && r.is_open === true
  );
  if (oneOffModified.length > 0) {
    const range2 = pickSortedRange(oneOffModified);
    if (range2) {
      return {
        openTime: range2.open,
        closeTime: range2.close,
        isClosed: false,
        closureName: oneOffModified[0].name || void 0,
        isUsingDefaults: false
      };
    }
  }
  if (tier === "standard" && dayOfWeek === 0) {
    return {
      openTime: DEFAULT_OPEN_TIME,
      closeTime: DEFAULT_CLOSE_TIME,
      isClosed: true,
      closureName: "Sunday - HopDrive is closed",
      isUsingDefaults: false
    };
  }
  const closedForDay = allRows.find(
    (r) => String(r.location_id ?? "") === locationIdStr && r.type === "business-hours" && r.day_of_week === dayOfWeek && r.is_open === false
  );
  if (closedForDay) {
    return {
      openTime: DEFAULT_OPEN_TIME,
      closeTime: DEFAULT_CLOSE_TIME,
      isClosed: true,
      closureName: closedForDay.name || "Location Closed",
      isUsingDefaults: false
    };
  }
  const locationSpecificHours = allRows.filter(
    (r) => String(r.location_id ?? "") === locationIdStr && r.type === "business-hours" && r.day_of_week === dayOfWeek && r.is_open === true
  );
  const defaultHours = allRows.filter(
    (r) => (r.location_id === null || r.location_id === void 0) && r.type === "default-hours" && r.day_of_week === dayOfWeek && r.is_open === true
  );
  const hoursToUse = locationSpecificHours.length > 0 ? locationSpecificHours : defaultHours;
  if (hoursToUse.length === 0) {
    return defaults();
  }
  const range = pickSortedRange(hoursToUse);
  if (!range) {
    return defaults();
  }
  return {
    openTime: range.open,
    closeTime: range.close,
    isClosed: false,
    isUsingDefaults: false
  };
}

// src/features/slots/calculateMovePairTimes.ts
function calculateMovePairTimes(selectedTime, usecaseKey, parentDurationSec) {
  const base = (0, import_dayjs.default)(selectedTime);
  const isConciergeLoanerPu = usecaseKey === "concierge-loaner-pu";
  if (isConciergeLoanerPu) {
    return {
      parentPickup: base.subtract(parentDurationSec, "second").toISOString(),
      parentDelivery: base.toISOString(),
      childPickup: base.toISOString(),
      childDelivery: base.add(parentDurationSec, "second").toISOString()
    };
  }
  return {
    parentPickup: base.toISOString(),
    parentDelivery: base.add(parentDurationSec, "second").toISOString(),
    childPickup: base.add(parentDurationSec, "second").toISOString(),
    childDelivery: base.add(parentDurationSec * 2, "second").toISOString()
  };
}

// src/features/slots/filterPastSlots.ts
function filterPastSlots(slots, timezoneStr, now) {
  const anchor = (now ? (0, import_dayjs.default)(now) : (0, import_dayjs.default)()).tz(timezoneStr);
  const anchorMs = anchor.valueOf();
  return slots.filter((slot) => {
    const slotMs = (0, import_dayjs.default)(slot.pickup_start).valueOf();
    return slotMs > anchorMs;
  });
}

// src/features/formatting/formatDisplayLabel.ts
function formatDisplayLabel(datetime, timezoneStr, now) {
  const target = (0, import_dayjs.default)(datetime).tz(timezoneStr);
  const anchor = (now != null ? (0, import_dayjs.default)(now) : (0, import_dayjs.default)()).tz(timezoneStr);
  const time = target.format("h:mm A");
  if (target.isSame(anchor, "day")) {
    return `Today ${time}`;
  }
  if (target.isSame(anchor.add(1, "day"), "day")) {
    return `Tomorrow ${time}`;
  }
  if (target.isBefore(anchor.add(7, "day"))) {
    return `${target.format("dddd")} ${time}`;
  }
  return `${target.format("MMM D")} ${time}`;
}

// src/features/availability/scenarioTimeUtils.ts
function getTimingMove(scenario) {
  const moves = scenario?.moves?.map((link) => link.move).filter((m) => !!m) ?? [];
  if (moves.length === 0) return null;
  if (isConciergePickupScenario(scenario?.scenario_key) || isConciergeReturnScenario(scenario?.scenario_key)) {
    const rideMove = moves.find((m) => m.move_type === "ride" && m.active !== 0);
    if (rideMove) return rideMove;
    const driveMove = moves.find((m) => m.move_type === "drive");
    if (driveMove) return driveMove;
    return moves[0];
  }
  if (scenario?.scenario_key === "concierge-loaner-pu") {
    const childMove = moves.find((m) => m.parent_move_id != null);
    if (childMove) return childMove;
  }
  if (scenario?.scenario_key === "concierge-loaner-ret") {
    const parentMove2 = moves.find((m) => m.parent_move_id == null);
    if (parentMove2) return parentMove2;
  }
  const parentMove = moves.find((m) => m.parent_move_id == null);
  return parentMove ?? moves[0];
}

// src/features/availability/timeRangeUtils.ts
var SLOT_ROUNDING_MINUTES = 5;
function roundToNearestInterval(time, intervalMinutes = SLOT_ROUNDING_MINUTES) {
  const minutes = time.minute();
  const roundedMinutes = Math.ceil(minutes / intervalMinutes) * intervalMinutes;
  return time.minute(roundedMinutes).second(0).millisecond(0);
}
function rangesOverlap(a, b) {
  return a.start < b.end && b.start < a.end;
}
function hasConflict(testRange, existingRanges) {
  return existingRanges.some((existing) => rangesOverlap(testRange, existing));
}
function getRideVisualDurationSec(rideLane) {
  if (!rideLane) return 0;
  const raw = (rideLane.duration_sec ?? 0) - (rideLane.pickup_inspection_sec ?? 0) - (rideLane.delivery_inspection_sec ?? 0) + (rideLane.return_ride_wait_sec ?? 0);
  return Math.max(0, raw);
}
function getScenarioTimeRange(scenario, timezoneStr) {
  const moves = scenario?.moves?.map((link) => link.move).filter((m) => !!m) ?? [];
  if (moves.length === 0) return null;
  const getMoveStartTime = (move) => {
    const timeStr = move.pickup_started ?? move.ready_by;
    if (!timeStr) return null;
    return (0, import_dayjs.default)(timeStr).tz(timezoneStr);
  };
  const getMoveEndTime = (move) => {
    const startTime = getMoveStartTime(move);
    if (!startTime) return null;
    let durationSec = 0;
    if (isConciergePickupScenario(scenario?.scenario_key)) {
      durationSec = move.lane?.duration_sec ?? 0;
    } else if (isConciergeReturnScenario(scenario?.scenario_key)) {
      durationSec = move.lane?.inverse?.duration_sec ?? move.lane?.duration_sec ?? 0;
    } else {
      durationSec = move.lane?.duration_sec ?? 0;
    }
    if (durationSec === 0) return null;
    return startTime.add(durationSec, "seconds");
  };
  let earliestStart = null;
  let latestEnd = null;
  const hasRide = moves.some((m) => m.move_type === "ride" && m.active !== 0);
  const driveMove = moves.find((m) => m.move_type === "drive");
  const rideMove = moves.find((m) => m.move_type === "ride" && m.active !== 0);
  const isAnyConciergeVariant = scenario?.scenario_key === "concierge-loaner-pu" || scenario?.scenario_key === "concierge-loaner-ret" || isConciergePickupScenario(scenario?.scenario_key) || isConciergeReturnScenario(scenario?.scenario_key);
  if (isAnyConciergeVariant) {
    const timingMove = getTimingMove(scenario ?? null);
    if (hasRide && (driveMove?.pickup_started || driveMove?.ready_by)) {
      const appointmentTime = (0, import_dayjs.default)(driveMove?.pickup_started ?? driveMove?.ready_by).tz(timezoneStr);
      if (isConciergePickupScenario(scenario?.scenario_key)) {
        earliestStart = appointmentTime.subtract(getRideVisualDurationSec(rideMove?.lane), "seconds");
        const driveLane = driveMove?.lane;
        const driveDurationSec = driveLane?.duration_sec ?? 0;
        latestEnd = appointmentTime.add(driveDurationSec, "seconds");
      } else if (isConciergeReturnScenario(scenario?.scenario_key)) {
        const driveLane = driveMove?.lane;
        const driveDurationSec = driveLane?.duration_sec ?? 0;
        earliestStart = appointmentTime.subtract(driveDurationSec, "seconds");
        latestEnd = appointmentTime.add(getRideVisualDurationSec(rideMove?.lane), "seconds");
      }
    } else if (timingMove) {
      const appointmentTime = getMoveStartTime(timingMove);
      if (appointmentTime) {
        if (isConciergePickupScenario(scenario?.scenario_key)) {
          const travelDuration = timingMove.lane?.inverse?.duration_sec ?? timingMove.lane?.duration_sec ?? 0;
          earliestStart = appointmentTime.subtract(travelDuration, "seconds");
          latestEnd = getMoveEndTime(timingMove);
        } else if (isConciergeReturnScenario(scenario?.scenario_key)) {
          const travelToCustomer = timingMove.lane?.inverse?.duration_sec ?? timingMove.lane?.duration_sec ?? 0;
          const returnToDealer = timingMove.lane?.duration_sec ?? 0;
          earliestStart = appointmentTime.subtract(travelToCustomer, "seconds");
          latestEnd = appointmentTime.add(returnToDealer, "seconds");
        } else if (scenario?.scenario_key === "concierge-loaner-pu") {
          const parentMove = moves.find((m) => m.parent_move_id == null);
          const childMove = moves.find((m) => m.parent_move_id != null);
          const parentDurationSec = parentMove?.lane?.duration_sec ?? 0;
          const childDurationSec = childMove?.lane?.duration_sec ?? 0;
          earliestStart = appointmentTime.subtract(parentDurationSec, "seconds");
          latestEnd = appointmentTime.add(childDurationSec, "seconds");
        } else if (scenario?.scenario_key === "concierge-loaner-ret") {
          const parentMove = moves.find((m) => m.parent_move_id == null);
          const childMove = moves.find((m) => m.parent_move_id != null);
          const parentDurationSec = parentMove?.lane?.duration_sec ?? 0;
          const childDurationSec = childMove?.lane?.duration_sec ?? 0;
          earliestStart = appointmentTime.subtract(childDurationSec, "seconds");
          latestEnd = appointmentTime.add(parentDurationSec, "seconds");
        }
      }
    }
  }
  if (!earliestStart) {
    for (const move of moves) {
      const startTime = getMoveStartTime(move);
      if (startTime && (!earliestStart || startTime.isBefore(earliestStart))) {
        earliestStart = startTime;
      }
    }
  }
  if (!latestEnd) {
    for (const move of moves) {
      const endTime = getMoveEndTime(move);
      if (endTime && (!latestEnd || endTime.isAfter(latestEnd))) {
        latestEnd = endTime;
      }
    }
  }
  if (!earliestStart || !latestEnd) return null;
  return {
    start: earliestStart.toDate(),
    end: latestEnd.toDate()
  };
}
function getTimeRangesFromScenarios(scenarios, timezoneStr) {
  const ranges = [];
  for (const scenario of scenarios) {
    const range = getScenarioTimeRange(scenario, timezoneStr);
    if (range) ranges.push(range);
  }
  return ranges;
}
function addBufferToRange(range, bufferMinutes) {
  return {
    start: (0, import_dayjs.default)(range.start).subtract(bufferMinutes, "minutes").toDate(),
    end: (0, import_dayjs.default)(range.end).add(bufferMinutes, "minutes").toDate()
  };
}
function mergeOverlappingRanges(ranges) {
  if (ranges.length === 0) return [];
  if (ranges.length === 1) return [{ ...ranges[0] }];
  const sorted = [...ranges].sort((a, b) => a.start.getTime() - b.start.getTime());
  const merged = [{ ...sorted[0] }];
  for (let i = 1; i < sorted.length; i++) {
    const current = sorted[i];
    const last = merged[merged.length - 1];
    if (current.start <= last.end) {
      last.end = (0, import_dayjs.default)(last.end).isAfter((0, import_dayjs.default)(current.end)) ? last.end : current.end;
    } else {
      merged.push({ ...current });
    }
  }
  return merged;
}
function findAvailableGaps(busyRanges, dayStart, dayEnd, bufferMinutes = 0) {
  void bufferMinutes;
  if (busyRanges.length === 0) {
    return [{ start: dayStart, end: dayEnd }];
  }
  const clamped = busyRanges.filter((range) => range.start < dayEnd && range.end > dayStart).map((range) => ({
    start: range.start < dayStart ? dayStart : range.start,
    end: range.end > dayEnd ? dayEnd : range.end
  }));
  if (clamped.length === 0) {
    return [{ start: dayStart, end: dayEnd }];
  }
  const merged = mergeOverlappingRanges(clamped);
  const gaps = [];
  if (merged[0].start > dayStart) {
    gaps.push({ start: dayStart, end: merged[0].start });
  }
  for (let i = 0; i < merged.length - 1; i++) {
    const gapStart = merged[i].end;
    const gapEnd = merged[i + 1].start;
    if (gapStart < gapEnd) {
      gaps.push({ start: gapStart, end: gapEnd });
    }
  }
  if (merged[merged.length - 1].end < dayEnd) {
    gaps.push({ start: merged[merged.length - 1].end, end: dayEnd });
  }
  return gaps;
}
function generateSlotsInGap(gap, slotDurationSec, bufferMinutes = 0, appointmentMode = false, inverseDurationSec = 0) {
  const slots = [];
  const gapStartDayjs = (0, import_dayjs.default)(gap.start);
  const gapEndDayjs = (0, import_dayjs.default)(gap.end);
  if (appointmentMode && inverseDurationSec > 0) {
    let currentAppointmentTime = roundToNearestInterval(
      gapStartDayjs.add(inverseDurationSec, "seconds")
    );
    while (true) {
      const driverDepartureTime = currentAppointmentTime.subtract(inverseDurationSec, "seconds");
      const forwardDurationSec = slotDurationSec - inverseDurationSec;
      const serviceCompletionTime = currentAppointmentTime.add(forwardDurationSec, "seconds");
      if (serviceCompletionTime.isAfter(gapEndDayjs)) break;
      slots.push({
        start: driverDepartureTime.toDate(),
        end: serviceCompletionTime.toDate()
      });
      currentAppointmentTime = serviceCompletionTime.add(bufferMinutes, "minutes").add(inverseDurationSec, "seconds");
      currentAppointmentTime = roundToNearestInterval(currentAppointmentTime);
    }
  } else {
    let currentSlotStart = roundToNearestInterval(gapStartDayjs);
    let slotEnd = currentSlotStart.add(slotDurationSec, "seconds");
    while (!slotEnd.isAfter(gapEndDayjs)) {
      slots.push({
        start: currentSlotStart.toDate(),
        end: slotEnd.toDate()
      });
      currentSlotStart = slotEnd.add(bufferMinutes, "minutes");
      currentSlotStart = roundToNearestInterval(currentSlotStart);
      slotEnd = currentSlotStart.add(slotDurationSec, "seconds");
    }
  }
  return slots;
}
function generateGapBasedSlots(busyRanges, slotDurationSec, returnDurationSec, dayStart, dayEnd, bufferMinutes = 0, minGapSizeMinutes = 0, appointmentMode = false) {
  const totalDurationSec = slotDurationSec + returnDurationSec;
  const gaps = findAvailableGaps(busyRanges, dayStart, dayEnd, bufferMinutes);
  const allSlots = [];
  for (const gap of gaps) {
    const gapDurationMinutes = (0, import_dayjs.default)(gap.end).diff((0, import_dayjs.default)(gap.start), "minutes");
    if (minGapSizeMinutes > 0 && gapDurationMinutes < minGapSizeMinutes) continue;
    const gapSlots = generateSlotsInGap(
      gap,
      totalDurationSec,
      bufferMinutes,
      appointmentMode,
      returnDurationSec
    );
    allSlots.push(...gapSlots);
  }
  return allSlots;
}

// src/features/availability/algorithmUtils.ts
function calculateBusyMinutes(scenarios, bufferMinutes, timezoneStr) {
  if (scenarios.length === 0) return 0;
  let totalMinutes = 0;
  for (const scenario of scenarios) {
    const range = getScenarioTimeRange(scenario, timezoneStr);
    if (range) {
      totalMinutes += (0, import_dayjs.default)(range.end).diff((0, import_dayjs.default)(range.start), "minute");
    }
  }
  totalMinutes += Math.max(0, scenarios.length - 1) * bufferMinutes;
  return totalMinutes;
}
function calculateBusinessHoursMinutes(openTime, closeTime, selectedDate, timezoneStr) {
  const [openHour, openMinute, openSecond = 0] = openTime.split(":").map(Number);
  const [closeHour, closeMinute, closeSecond = 0] = closeTime.split(":").map(Number);
  const startOfDay = import_dayjs.default.tz(selectedDate, timezoneStr).hour(openHour).minute(openMinute).second(openSecond);
  const endOfDay = import_dayjs.default.tz(selectedDate, timezoneStr).hour(closeHour).minute(closeMinute).second(closeSecond);
  return endOfDay.diff(startOfDay, "minute");
}
function calculateDriverUtilization(scenarios, businessHours, selectedDate, timezoneStr, bufferMinutes) {
  const busyMinutes = calculateBusyMinutes(scenarios, bufferMinutes, timezoneStr);
  const totalMinutes = calculateBusinessHoursMinutes(
    businessHours.openTime,
    businessHours.closeTime,
    selectedDate,
    timezoneStr
  );
  if (totalMinutes === 0) return 0;
  return busyMinutes / totalMinutes;
}
function formatTimeString(date, timezoneStr) {
  return (0, import_dayjs.default)(date).tz(timezoneStr).format("h:mm A");
}
function createTimeSlot(startTime, lane, timezoneStr, endTime, returnEndTime) {
  let calculatedEndTime;
  let calculatedReturnEndTime;
  if (endTime && returnEndTime) {
    calculatedEndTime = endTime;
    calculatedReturnEndTime = returnEndTime;
  } else {
    const outboundDurationSec = lane.duration_sec ?? 0;
    const returnDurationSec = lane.inverse?.duration_sec ?? 0;
    calculatedEndTime = (0, import_dayjs.default)(startTime).add(outboundDurationSec, "second").toDate();
    calculatedReturnEndTime = (0, import_dayjs.default)(calculatedEndTime).add(returnDurationSec, "second").toDate();
  }
  return {
    startTime,
    endTime: calculatedEndTime,
    returnEndTime: calculatedReturnEndTime,
    startTimeString: formatTimeString(startTime, timezoneStr),
    endTimeString: formatTimeString(calculatedEndTime, timezoneStr),
    returnEndTimeString: formatTimeString(calculatedReturnEndTime, timezoneStr)
  };
}
function filterPastSlots2(slots, timezoneStr) {
  const now = (0, import_dayjs.default)().tz(timezoneStr).toDate();
  return slots.filter((slot) => slot.startTime > now);
}
function sortSlotsByTime(slots) {
  return [...slots].sort((a, b) => a.startTime.getTime() - b.startTime.getTime());
}
function busyRangesFromScenarios(scenarios, timezoneStr) {
  const ranges = [];
  for (const scenario of scenarios) {
    const range = getScenarioTimeRange(scenario, timezoneStr);
    if (range) ranges.push({ start: range.start, end: range.end });
  }
  return ranges;
}

// src/features/availability/checkMoveOverlap.ts
function checkMoveOverlap(params) {
  const { candidateRanges, allDriverScenarios, tier, targetDriverIndex, bufferMinutes = 0, timezone: timezone2 } = params;
  if (candidateRanges.length === 0 || allDriverScenarios.length === 0) {
    return { overlaps: false, conflicts: [] };
  }
  const conflictsForRow = (rowScenarios) => {
    const busy = busyRangesFromScenarios([...rowScenarios], timezone2);
    const hits = [];
    busy.forEach((range) => {
      const test = bufferMinutes > 0 ? addBufferToRange(range, bufferMinutes) : range;
      if (candidateRanges.some((candidate) => rangesOverlap(candidate, test))) {
        hits.push(range);
      }
    });
    return hits;
  };
  if (tier === "lite" && targetDriverIndex != null) {
    const conflicts = conflictsForRow(allDriverScenarios[targetDriverIndex] ?? []);
    return { overlaps: conflicts.length > 0, conflicts };
  }
  const allConflicts = [];
  for (const rowScenarios of allDriverScenarios) {
    const conflicts = conflictsForRow(rowScenarios);
    if (conflicts.length === 0) {
      return { overlaps: false, conflicts: [] };
    }
    allConflicts.push(...conflicts);
  }
  return { overlaps: true, conflicts: allConflicts };
}

// src/features/availability/assignDriverRow.ts
function assignDriverRow(params) {
  const { candidateRanges, allDriverScenarios, driverCount, bufferMinutes = 0, timezone: timezone2 } = params;
  if (driverCount <= 0 || candidateRanges.length === 0) return null;
  const rowConflicts = (rowScenarios) => {
    const busy = busyRangesFromScenarios([...rowScenarios], timezone2);
    return busy.some((range) => {
      const test = bufferMinutes > 0 ? addBufferToRange(range, bufferMinutes) : range;
      return candidateRanges.some((candidate) => rangesOverlap(candidate, test));
    });
  };
  for (let rowIndex = 0; rowIndex < driverCount; rowIndex++) {
    if (!rowConflicts(allDriverScenarios[rowIndex] ?? [])) {
      return { rowIndex, conflictFree: true };
    }
  }
  let leastLoadedIndex = 0;
  for (let rowIndex = 1; rowIndex < driverCount; rowIndex++) {
    const load = allDriverScenarios[rowIndex]?.length ?? 0;
    if (load < (allDriverScenarios[leastLoadedIndex]?.length ?? 0)) {
      leastLoadedIndex = rowIndex;
    }
  }
  return { rowIndex: leastLoadedIndex, conflictFree: false };
}

// src/features/availability/persistedRow.ts
function getPersistedRowNumber(scenario, driverCount) {
  const moves = scenario?.moves?.map((link) => link.move) ?? [];
  for (const move of moves) {
    const config = move?.config;
    if (!config || typeof config !== "object") continue;
    const value = config.driver_row_number;
    if (value == null) continue;
    return typeof value === "number" && Number.isInteger(value) && value >= 0 && value < driverCount ? value : null;
  }
  return null;
}

// src/features/availability/driverScheduleOverlay.ts
function calculateUnavailableBlocks(driverSchedule, selectedDate, timezoneStr) {
  const selectedDay = (0, import_dayjs.default)(selectedDate).add(12, "hours").tz(timezoneStr);
  const dayStart = selectedDay.startOf("day");
  const dayEnd = selectedDay.endOf("day");
  if (!driverSchedule || driverSchedule.length === 0) {
    return [
      {
        startTime: dayStart.toISOString(),
        endTime: dayEnd.toISOString(),
        reason: "not-scheduled"
      }
    ];
  }
  const dayOfWeek = selectedDay.day();
  const year = selectedDay.year();
  const month = selectedDay.month() + 1;
  const day = selectedDay.date();
  const oneOffDay = driverSchedule.find(
    (s) => s.type === "one-off" && s.year === year && s.month === month && s.day === day
  );
  if (oneOffDay) {
    if (!oneOffDay.isOpen) {
      return [
        {
          startTime: dayStart.toISOString(),
          endTime: dayEnd.toISOString(),
          reason: "one-off"
        }
      ];
    }
    if (oneOffDay.timeBlocks && oneOffDay.timeBlocks.length > 0) {
      return buildUnavailableBlocksFromTimeBlocks(
        oneOffDay.timeBlocks,
        dayStart,
        dayEnd,
        "one-off"
      );
    }
  }
  const daySchedule = driverSchedule.find(
    (s) => s.dayOfWeek === dayOfWeek && s.type !== "one-off"
  );
  if (!daySchedule || !daySchedule.isOpen) {
    return [
      {
        startTime: dayStart.toISOString(),
        endTime: dayEnd.toISOString(),
        reason: "off-shift"
      }
    ];
  }
  if (!daySchedule.timeBlocks || daySchedule.timeBlocks.length === 0) {
    return [
      {
        startTime: dayStart.toISOString(),
        endTime: dayEnd.toISOString(),
        reason: "off-shift"
      }
    ];
  }
  return buildUnavailableBlocksFromTimeBlocks(
    daySchedule.timeBlocks,
    dayStart,
    dayEnd,
    "off-shift"
  );
}
function buildUnavailableBlocksFromTimeBlocks(timeBlocks, dayStart, dayEnd, reason) {
  const workingRanges = [];
  for (const block of timeBlocks) {
    if (!block.openTime || !block.closedTime) continue;
    const [openHour, openMin, openSec = 0] = block.openTime.split(":").map(Number);
    const [closeHour, closeMin, closeSec = 0] = block.closedTime.split(":").map(Number);
    const open = dayStart.hour(openHour).minute(openMin).second(openSec);
    const close = dayStart.hour(closeHour).minute(closeMin).second(closeSec);
    if (close.isBefore(open)) {
      workingRanges.push({ start: open.toDate(), end: dayEnd.toDate() });
      workingRanges.push({ start: dayStart.toDate(), end: close.toDate() });
    } else {
      workingRanges.push({ start: open.toDate(), end: close.toDate() });
    }
  }
  if (workingRanges.length === 0) {
    return [
      {
        startTime: dayStart.toISOString(),
        endTime: dayEnd.toISOString(),
        reason
      }
    ];
  }
  return findAvailableGaps(workingRanges, dayStart.toDate(), dayEnd.toDate()).map((gap) => ({
    startTime: gap.start.toISOString(),
    endTime: gap.end.toISOString(),
    reason
  }));
}
function getUnavailableBlockLabel(reason) {
  switch (reason) {
    case "off-shift":
      return "Driver Off Shift";
    case "one-off":
      return "Driver Unavailable";
    case "not-scheduled":
      return "No Schedule Data";
  }
}
function unavailableBlocksToTimeRanges(blocks) {
  return blocks.map((block) => ({
    start: new Date(block.startTime),
    end: new Date(block.endTime)
  }));
}

// src/features/availability/scenarioDistribution.ts
import { getLogger as getLogger2 } from "@hopdrive/sdk-core";
function calculateScenarioDuration(scenario, bufferMinutes = 0) {
  const moves = scenario.moves?.map((link) => link.move) ?? [];
  const totalDurationSeconds = moves.reduce(
    (sum, move) => sum + (move?.lane?.duration_sec ?? 0),
    0
  );
  const durationMinutes = totalDurationSeconds / 60;
  const bufferTime = moves.length * bufferMinutes;
  return durationMinutes + bufferTime;
}
function calculateTotalDuration(scenarios, bufferMinutes = 0) {
  return scenarios.reduce((total, scenario) => total + calculateScenarioDuration(scenario, bufferMinutes), 0);
}
function getScenarioStartTime(scenario) {
  const moves = scenario.moves?.map((link) => link.move).filter((m) => !!m) ?? [];
  if (moves.length === 0) return /* @__PURE__ */ new Date();
  const timingMove = getTimingMove(scenario);
  const moveToUse = timingMove ?? moves[0];
  const timeString = moveToUse?.ready_by ?? (/* @__PURE__ */ new Date()).toISOString();
  return new Date(timeString);
}
function sortScenariosByTime(scenarios) {
  return [...scenarios].sort(
    (a, b) => getScenarioStartTime(a).getTime() - getScenarioStartTime(b).getTime()
  );
}
function distributeEvenlyByDuration(scenarios, driverCount, bufferMinutes = 0, timezoneStr = "America/Los_Angeles", seedRows) {
  const log = getLogger2();
  const result = Array.from({ length: driverCount }, () => []);
  const driverTimeRanges = Array.from({ length: driverCount }, (_, i) => {
    const ranges = [];
    for (const seeded of seedRows?.[i] ?? []) {
      const range = getScenarioTimeRange(seeded, timezoneStr);
      if (range) ranges.push(range);
    }
    return ranges;
  });
  const driverLoads = Array.from(
    { length: driverCount },
    (_, i) => calculateTotalDuration(seedRows?.[i] ?? [], bufferMinutes)
  );
  const overflowScenarios = [];
  const sortedScenarios = sortScenariosByTime(scenarios);
  for (const scenario of sortedScenarios) {
    const scenarioTimeRange = getScenarioTimeRange(scenario, timezoneStr);
    const scenarioDuration = calculateScenarioDuration(scenario, bufferMinutes);
    if (!scenarioTimeRange) {
      log.warn("distributeEvenlyByDuration: scenario has no valid time range; assigning by load only", {
        scenarioId: scenario.id ?? null
      });
      const minLoadIndex = driverLoads.indexOf(Math.min(...driverLoads));
      result[minLoadIndex].push(scenario);
      driverLoads[minLoadIndex] += scenarioDuration;
      continue;
    }
    const driverIndicesByLoad = Array.from({ length: driverCount }, (_, i) => i).sort(
      (a, b) => driverLoads[a] - driverLoads[b]
    );
    let assigned = false;
    for (const driverIndex of driverIndicesByLoad) {
      if (!hasConflict(scenarioTimeRange, driverTimeRanges[driverIndex])) {
        result[driverIndex].push(scenario);
        driverTimeRanges[driverIndex].push(scenarioTimeRange);
        driverLoads[driverIndex] += scenarioDuration;
        assigned = true;
        break;
      }
    }
    if (!assigned) {
      log.warn("distributeEvenlyByDuration: scenario has time conflicts with all drivers; overflow", {
        scenarioId: scenario.id ?? null
      });
      overflowScenarios.push(scenario);
    }
  }
  if (overflowScenarios.length > 0) {
    log.warn(
      "distributeEvenlyByDuration: overflow scenarios assigned despite conflicts (strict capacity)",
      { overflowCount: overflowScenarios.length }
    );
    overflowScenarios.forEach((scenario, idx) => {
      const targetIndex = idx % driverCount;
      result[targetIndex].push(scenario);
    });
  }
  return result;
}
function distributeScenarios(scenarios, driverCount, strategy = "balance-drivers-v1", bufferMinutes = 0, timezoneStr = "America/Los_Angeles", seedRows) {
  const log = getLogger2();
  if (driverCount <= 0) {
    log.warn("distributeScenarios: driverCount must be > 0; returning empty array", { driverCount });
    return [];
  }
  if (scenarios.length === 0) {
    return Array.from({ length: driverCount }, () => []);
  }
  switch (strategy) {
    case "balance-drivers-v1":
      return distributeEvenlyByDuration(scenarios, driverCount, bufferMinutes, timezoneStr, seedRows);
    default:
      log.warn("distributeScenarios: unknown strategy; falling back to balance-drivers-v1", { strategy });
      return distributeEvenlyByDuration(scenarios, driverCount, bufferMinutes, timezoneStr, seedRows);
  }
}

// src/features/availability/prepareDriverScenarios.ts
function extractOfferedScenariosByDriver(scenarios) {
  const byDriver = /* @__PURE__ */ new Map();
  for (const scenario of scenarios) {
    const firstMoveLink = scenario.moves?.[0];
    const isAssigned = !!firstMoveLink?.move?.driver_id;
    if (isAssigned) continue;
    const bundleLinks = scenario.bundletoscenarios ?? [];
    for (const bundleLink of bundleLinks) {
      const offers = bundleLink.bundle?.offers ?? [];
      for (const offer of offers) {
        if (offer.status !== "offered") continue;
        const driverId = offer.driver?.id;
        if (!driverId) continue;
        if (!byDriver.has(driverId)) {
          byDriver.set(driverId, []);
        }
        const list = byDriver.get(driverId);
        if (!list.some((s) => s.id === scenario.id)) {
          list.push(scenario);
        }
      }
    }
  }
  return byDriver;
}
function prepareStandardTierScenarios(params) {
  const { scenarios, algorithm, driverCount, bufferMinutes, timezone: timezone2, offeredScenariosByDriver } = params;
  if (driverCount <= 0) {
    return { allDriverScenarios: [], offeredScenariosByDriver, driverCount: 0 };
  }
  const assignedScenarios = [];
  const unassignedScenarios = [];
  for (const scenario of scenarios) {
    const driverId = scenario.moves?.[0]?.move?.driver_id;
    if (driverId) {
      assignedScenarios.push(scenario);
    } else {
      unassignedScenarios.push(scenario);
    }
  }
  const scenariosByRealDriver = /* @__PURE__ */ new Map();
  for (const scenario of assignedScenarios) {
    const driverId = scenario.moves?.[0]?.move?.driver_id;
    if (driverId) {
      if (!scenariosByRealDriver.has(driverId)) {
        scenariosByRealDriver.set(driverId, []);
      }
      scenariosByRealDriver.get(driverId).push(scenario);
    }
  }
  const realDriverIds = Array.from(
    /* @__PURE__ */ new Set([...scenariosByRealDriver.keys(), ...offeredScenariosByDriver.keys()])
  );
  const pinnedSeedRows = Array.from({ length: driverCount }, () => []);
  const rowlessScenarios = [];
  for (const scenario of unassignedScenarios) {
    const rowNumber = getPersistedRowNumber(scenario, driverCount);
    if (rowNumber != null) {
      pinnedSeedRows[rowNumber].push(scenario);
    } else {
      rowlessScenarios.push(scenario);
    }
  }
  const distributedUnassigned = algorithm.distributeScenarios({
    scenarios: rowlessScenarios,
    driverCount,
    bufferMinutes,
    timezone: timezone2,
    seedRows: pinnedSeedRows
  });
  const allDriverScenarios = [];
  for (let i = 0; i < driverCount; i++) {
    const assignedForThisRow = [];
    realDriverIds.forEach((realDriverId, realDriverIndex) => {
      if (realDriverIndex % driverCount === i) {
        assignedForThisRow.push(...scenariosByRealDriver.get(realDriverId) ?? []);
      }
    });
    const offeredForThisRow = [];
    realDriverIds.forEach((realDriverId, realDriverIndex) => {
      if (realDriverIndex % driverCount === i) {
        offeredForThisRow.push(...offeredScenariosByDriver.get(realDriverId) ?? []);
      }
    });
    const distributedForThisRow = distributedUnassigned[i] ?? [];
    const merged = sortScenariosByTime([
      ...assignedForThisRow,
      ...pinnedSeedRows[i],
      ...distributedForThisRow,
      ...offeredForThisRow
    ]);
    allDriverScenarios.push(merged);
  }
  return { allDriverScenarios, offeredScenariosByDriver, driverCount };
}
function prepareLiteTierScenarios(params) {
  const { scenarios, activeDrivers, offeredScenariosByDriver } = params;
  const scenariosByDriver = /* @__PURE__ */ new Map();
  for (const scenario of scenarios) {
    const driverId = scenario.moves?.[0]?.move?.driver_id;
    if (driverId) {
      const key = String(driverId);
      if (!scenariosByDriver.has(key)) {
        scenariosByDriver.set(key, []);
      }
      scenariosByDriver.get(key).push(scenario);
    }
  }
  const allDriverScenarios = activeDrivers.map((driver) => {
    const driverIdKey = String(driver.id);
    const regular = scenariosByDriver.get(driverIdKey) ?? [];
    const offered = offeredScenariosByDriver.get(driver.id) ?? [];
    return [...regular, ...offered];
  });
  return {
    allDriverScenarios,
    offeredScenariosByDriver,
    driverCount: activeDrivers.length
  };
}
function prepareDriverScenariosForAlgorithm(params) {
  const {
    scenarios,
    tier,
    algorithm,
    driverCount = 2,
    bufferMinutes = 0,
    timezone: timezone2 = "America/Los_Angeles",
    activeDrivers
  } = params;
  const offeredScenariosByDriver = extractOfferedScenariosByDriver(scenarios);
  if (tier === "standard") {
    return prepareStandardTierScenarios({
      scenarios,
      algorithm,
      driverCount,
      bufferMinutes,
      timezone: timezone2,
      offeredScenariosByDriver
    });
  }
  return prepareLiteTierScenarios({
    scenarios,
    activeDrivers: activeDrivers ?? [],
    offeredScenariosByDriver
  });
}

// src/features/availability/algorithms/AlgorithmRegistry.ts
import { getLogger as getLogger5 } from "@hopdrive/sdk-core";

// src/features/availability/algorithms/BalanceDriversV1.ts
import { getLogger as getLogger3 } from "@hopdrive/sdk-core";
var BalanceDriversV1 = class {
  constructor() {
    this.name = "balance-drivers-v1";
    this.description = "Evenly distributes appointments across all drivers to balance workload and maximize fleet utilization.";
  }
  generateTimeSlots(params) {
    const {
      driverIndex,
      allDriverScenarios,
      lane,
      businessHours,
      selectedDate,
      timezone: timezone2,
      bufferMinutes,
      tier,
      driverSchedule
    } = params;
    const driverScenarios = allDriverScenarios[driverIndex] ?? [];
    const actuallyScheduled = filterActuallyScheduled(driverScenarios, tier);
    const appointmentRanges = busyRangesFromScenarios(actuallyScheduled, timezone2);
    const bufferedAppointmentRanges = bufferMinutes > 0 ? appointmentRanges.map((range) => ({
      start: range.start,
      end: (0, import_dayjs.default)(range.end).add(bufferMinutes, "minutes").toDate()
    })) : appointmentRanges;
    const busyRanges = [...bufferedAppointmentRanges];
    if (tier === "lite") {
      const unavailableBlocks = calculateUnavailableBlocks(driverSchedule, selectedDate, timezone2);
      busyRanges.push(...unavailableBlocksToTimeRanges(unavailableBlocks));
    }
    const { dayStart, dayEnd } = parseBusinessHoursToDayBounds(
      businessHours.openTime,
      businessHours.closeTime,
      selectedDate,
      timezone2
    );
    const slotDurationSec = lane.duration_sec ?? 0;
    const inverseDurationSec = lane.inverse?.duration_sec;
    const returnDurationSec = inverseDurationSec ?? slotDurationSec;
    if (inverseDurationSec == null && slotDurationSec > 0) {
      getLogger3().warn(
        "BalanceDriversV1: inverse lane missing; falling back to forward duration",
        {
          event: "inverse_lane_fallback",
          forwardDurationSec: slotDurationSec
        }
      );
    }
    const gapSlots = generateGapBasedSlots(
      busyRanges,
      slotDurationSec,
      returnDurationSec,
      dayStart,
      dayEnd,
      bufferMinutes,
      0,
      true
    );
    const timeSlots = gapSlots.map((gapSlot) => {
      const appointmentTime = (0, import_dayjs.default)(gapSlot.start).add(returnDurationSec, "seconds").toDate();
      return createTimeSlot(gapSlot.start, lane, timezone2, appointmentTime, gapSlot.end);
    });
    return sortSlotsByTime(filterPastSlots2(timeSlots, timezone2));
  }
  distributeScenarios(params) {
    const { scenarios, driverCount, bufferMinutes, timezone: timezone2, seedRows } = params;
    return distributeEvenlyByDuration(scenarios, driverCount, bufferMinutes, timezone2, seedRows);
  }
  getSuggestedTimes(params) {
    if (!params.lane) return [];
    const { lane, existingScenarios, businessHours, selectedDate, timezone: timezone2, bufferMinutes, count = 3 } = params;
    const actuallyScheduled = filterActuallyScheduledForSuggestions(existingScenarios);
    const appointmentRanges = busyRangesFromScenarios(actuallyScheduled, timezone2);
    const busyRanges = bufferMinutes > 0 ? appointmentRanges.map((range) => ({
      start: range.start,
      end: (0, import_dayjs.default)(range.end).add(bufferMinutes, "minutes").toDate()
    })) : appointmentRanges;
    const { dayStart, dayEnd } = parseBusinessHoursToDayBounds(
      businessHours.openTime,
      businessHours.closeTime,
      selectedDate,
      timezone2
    );
    const slotDurationSec = lane.duration_sec ?? 0;
    const inverseDurationSec = lane.inverse?.duration_sec;
    const returnDurationSec = inverseDurationSec ?? slotDurationSec;
    if (inverseDurationSec == null && slotDurationSec > 0) {
      getLogger3().warn(
        "BalanceDriversV1.getSuggestedTimes: inverse lane missing; falling back to forward duration",
        {
          event: "inverse_lane_fallback",
          forwardDurationSec: slotDurationSec
        }
      );
    }
    const gapSlots = generateGapBasedSlots(
      busyRanges,
      slotDurationSec,
      returnDurationSec,
      dayStart,
      dayEnd,
      bufferMinutes,
      0,
      true
    );
    const timeSlots = gapSlots.map((gapSlot) => {
      const appointmentTime = (0, import_dayjs.default)(gapSlot.start).add(returnDurationSec, "seconds").toDate();
      return createTimeSlot(gapSlot.start, lane, timezone2, appointmentTime, gapSlot.end);
    });
    const sortedSlots = sortSlotsByTime(filterPastSlots2(timeSlots, timezone2));
    return sortedSlots.slice(0, count).map((slot) => slot.startTime);
  }
};
function filterActuallyScheduled(scenarios, tier) {
  if (tier === "standard") {
    return [...scenarios];
  }
  return scenarios.filter((scenario) => {
    const timingMove = getTimingMove(scenario);
    if (timingMove?.driver_id != null) return true;
    const bundleLinks = scenario.bundletoscenarios ?? [];
    return bundleLinks.some((link) => (link.bundle?.offers?.length ?? 0) > 0);
  });
}
function filterActuallyScheduledForSuggestions(scenarios) {
  return scenarios.filter((scenario) => {
    const timingMove = getTimingMove(scenario);
    if (timingMove?.driver_id != null) return true;
    const bundleLinks = scenario.bundletoscenarios ?? [];
    return bundleLinks.some((link) => (link.bundle?.offers?.length ?? 0) > 0);
  });
}
function parseBusinessHoursToDayBounds(openTime, closeTime, selectedDate, timezoneStr) {
  const [openHour, openMinute, openSecond = 0] = openTime.split(":").map(Number);
  const [closeHour, closeMinute, closeSecond = 0] = closeTime.split(":").map(Number);
  const dayStart = import_dayjs.default.tz(selectedDate, timezoneStr).hour(openHour).minute(openMinute).second(openSecond).toDate();
  const dayEnd = import_dayjs.default.tz(selectedDate, timezoneStr).hour(closeHour).minute(closeMinute).second(closeSecond).toDate();
  return { dayStart, dayEnd };
}

// src/features/availability/algorithms/MaxFirstDriverV1.ts
import { getLogger as getLogger4 } from "@hopdrive/sdk-core";
var MaxFirstDriverV1 = class {
  constructor() {
    this.name = "max-first-driver-v1";
    this.description = "Fills first driver to 80% capacity before showing slots on subsequent drivers. Minimizes driver count and concentrates workload.";
    /** Utilization threshold for releasing slots to the next driver (0.0..1.0). */
    this.CAPACITY_THRESHOLD = 0.8;
  }
  generateTimeSlots(params) {
    const {
      driverIndex,
      allDriverScenarios,
      lane,
      businessHours,
      selectedDate,
      timezone: timezone2,
      bufferMinutes,
      tier,
      driverSchedule
    } = params;
    const { dayStart, dayEnd } = parseBusinessHoursToDayBounds(
      businessHours.openTime,
      businessHours.closeTime,
      selectedDate,
      timezone2
    );
    const driverScenarios = allDriverScenarios[driverIndex] ?? [];
    const actuallyScheduled = filterActuallyScheduled(driverScenarios, tier);
    const appointmentRanges = busyRangesFromScenarios(actuallyScheduled, timezone2);
    const bufferedAppointmentRanges = bufferMinutes > 0 ? appointmentRanges.map((range) => ({
      start: range.start,
      end: (0, import_dayjs.default)(range.end).add(bufferMinutes, "minutes").toDate()
    })) : appointmentRanges;
    const busyRanges = [...bufferedAppointmentRanges];
    if (tier === "lite") {
      const unavailableBlocks = calculateUnavailableBlocks(driverSchedule, selectedDate, timezone2);
      busyRanges.push(...unavailableBlocksToTimeRanges(unavailableBlocks));
    }
    const slotDurationSec = lane.duration_sec ?? 0;
    const inverseDurationSec = lane.inverse?.duration_sec;
    const returnDurationSec = inverseDurationSec ?? slotDurationSec;
    if (inverseDurationSec == null && slotDurationSec > 0) {
      getLogger4().warn(
        "MaxFirstDriverV1: inverse lane missing; falling back to forward duration",
        {
          event: "inverse_lane_fallback",
          forwardDurationSec: slotDurationSec
        }
      );
    }
    const gapSlots = generateGapBasedSlots(
      busyRanges,
      slotDurationSec,
      returnDurationSec,
      dayStart,
      dayEnd,
      bufferMinutes,
      0,
      true
    );
    const timeSlots = gapSlots.map((gapSlot) => {
      const appointmentTime = (0, import_dayjs.default)(gapSlot.start).add(returnDurationSec, "seconds").toDate();
      return createTimeSlot(gapSlot.start, lane, timezone2, appointmentTime, gapSlot.end);
    });
    const sortedSlots = sortSlotsByTime(filterPastSlots2(timeSlots, timezone2));
    if (driverIndex === 0) {
      return sortedSlots;
    }
    const previousDriverScenarios = filterActuallyScheduled(
      allDriverScenarios[driverIndex - 1] ?? [],
      tier
    );
    const previousDriverUtilization = calculateDriverUtilization(
      previousDriverScenarios,
      businessHours,
      selectedDate,
      timezone2,
      bufferMinutes
    );
    if (previousDriverUtilization < this.CAPACITY_THRESHOLD) {
      return [];
    }
    return sortedSlots;
  }
  distributeScenarios(params) {
    const log = getLogger4();
    const { scenarios, driverCount, bufferMinutes, timezone: timezone2, seedRows } = params;
    const driverRows = Array.from({ length: driverCount }, () => []);
    const driverLoads = Array(driverCount).fill(0);
    const sortedScenarios = [...scenarios].sort((a, b) => {
      const aTime = a.moves?.[0]?.move?.ready_by ?? "";
      const bTime = b.moves?.[0]?.move?.ready_by ?? "";
      return aTime.localeCompare(bTime);
    });
    let overflowCount = 0;
    for (const scenario of sortedScenarios) {
      let assigned = false;
      for (let driverIndex = 0; driverIndex < driverCount; driverIndex++) {
        const occupants = [...seedRows?.[driverIndex] ?? [], ...driverRows[driverIndex]];
        let hasConflictWithDriver = false;
        for (const existing of occupants) {
          if (this.scenariosConflict(scenario, existing, timezone2, bufferMinutes)) {
            hasConflictWithDriver = true;
            break;
          }
        }
        if (!hasConflictWithDriver) {
          driverRows[driverIndex].push(scenario);
          const range = getScenarioTimeRange(scenario, timezone2);
          const scenarioDuration = range ? (0, import_dayjs.default)(range.end).diff((0, import_dayjs.default)(range.start), "minute") : 0;
          driverLoads[driverIndex] += scenarioDuration + bufferMinutes;
          assigned = true;
          break;
        }
      }
      if (!assigned) {
        overflowCount++;
        const targetIndex = (overflowCount - 1) % driverCount;
        log.warn(
          "MaxFirstDriverV1: scenario could not fit any driver (strict capacity); round-robin overflow",
          {
            scenarioId: scenario.id ?? null,
            overflowTargetRow: targetIndex
          }
        );
        driverRows[targetIndex].push(scenario);
      }
    }
    if (overflowCount > 0) {
      log.warn("MaxFirstDriverV1: overflow assignments made", { overflowCount });
    }
    return driverRows;
  }
  getSuggestedTimes(params) {
    const { lane, existingScenarios, businessHours, selectedDate, timezone: timezone2, bufferMinutes, count = 3 } = params;
    const actuallyScheduled = filterActuallyScheduledForSuggestions(existingScenarios);
    const appointmentRanges = busyRangesFromScenarios(actuallyScheduled, timezone2);
    const busyRanges = bufferMinutes > 0 ? appointmentRanges.map((range) => ({
      start: range.start,
      end: (0, import_dayjs.default)(range.end).add(bufferMinutes, "minutes").toDate()
    })) : appointmentRanges;
    const { dayStart, dayEnd } = parseBusinessHoursToDayBounds(
      businessHours.openTime,
      businessHours.closeTime,
      selectedDate,
      timezone2
    );
    const slotDurationSec = lane.duration_sec ?? 0;
    const inverseDurationSec = lane.inverse?.duration_sec;
    const returnDurationSec = inverseDurationSec ?? slotDurationSec;
    if (inverseDurationSec == null && slotDurationSec > 0) {
      getLogger4().warn(
        "MaxFirstDriverV1.getSuggestedTimes: inverse lane missing; falling back to forward duration",
        {
          event: "inverse_lane_fallback",
          forwardDurationSec: slotDurationSec
        }
      );
    }
    const gapSlots = generateGapBasedSlots(
      busyRanges,
      slotDurationSec,
      returnDurationSec,
      dayStart,
      dayEnd,
      bufferMinutes,
      0,
      true
    );
    const timeSlots = gapSlots.map((gapSlot) => {
      const appointmentTime = (0, import_dayjs.default)(gapSlot.start).add(returnDurationSec, "seconds").toDate();
      return createTimeSlot(gapSlot.start, lane, timezone2, appointmentTime, gapSlot.end);
    });
    const sortedSlots = sortSlotsByTime(filterPastSlots2(timeSlots, timezone2));
    return sortedSlots.slice(0, count).map((slot) => slot.startTime);
  }
  /**
   * Conflict check that buffers `scenario1` only — prevents double-buffering
   * when both scenarios have already had their busy ranges buffered.
   */
  scenariosConflict(scenario1, scenario2, timezone2, bufferMinutes) {
    const range1 = getScenarioTimeRange(scenario1, timezone2);
    const range2 = getScenarioTimeRange(scenario2, timezone2);
    if (!range1 || !range2) return false;
    const bufferedRange1 = {
      start: (0, import_dayjs.default)(range1.start).subtract(bufferMinutes, "minute").toDate(),
      end: (0, import_dayjs.default)(range1.end).add(bufferMinutes, "minute").toDate()
    };
    return hasConflict(bufferedRange1, [range2]);
  }
};

// src/features/availability/algorithms/AlgorithmRegistry.ts
var ALGORITHMS = /* @__PURE__ */ new Map([
  ["balance-drivers-v1", new BalanceDriversV1()],
  ["max-first-driver-v1", new MaxFirstDriverV1()]
]);
var DEFAULT_ALGORITHM = "balance-drivers-v1";
function getAlgorithm(algorithmName) {
  const log = getLogger5();
  if (!algorithmName) {
    const defaultAlg2 = ALGORITHMS.get(DEFAULT_ALGORITHM);
    if (!defaultAlg2) {
      throw new Error(`Default algorithm "${DEFAULT_ALGORITHM}" not registered`);
    }
    return defaultAlg2;
  }
  const algorithm = ALGORITHMS.get(algorithmName);
  if (algorithm) return algorithm;
  log.warn(
    `AlgorithmRegistry: unknown algorithm "${algorithmName}"; falling back to "${DEFAULT_ALGORITHM}"`,
    { availableAlgorithms: Array.from(ALGORITHMS.keys()) }
  );
  const defaultAlg = ALGORITHMS.get(DEFAULT_ALGORITHM);
  if (!defaultAlg) {
    throw new Error(`Default algorithm "${DEFAULT_ALGORITHM}" not registered`);
  }
  return defaultAlg;
}
function getAvailableAlgorithms() {
  return Array.from(ALGORITHMS.keys());
}
function getAlgorithmDescriptions() {
  return Array.from(ALGORITHMS.entries()).map(([name, algorithm]) => ({
    name,
    description: algorithm.description
  }));
}

// src/features/availability/getAppointmentAvailability.ts
import { resolveExecutor as resolveExecutor3 } from "@hopdrive/sdk-core";
import { getCustomerConfig } from "@hopdrive/sdk-configs";

// src/features/availability/serviceArea.ts
var EARTH_RADIUS_MILES = 3958.8;
function distanceMiles(a, b) {
  const toRad = (deg) => deg * Math.PI / 180;
  const dLat = toRad(b.latitude - a.latitude);
  const dLon = toRad(b.longitude - a.longitude);
  const lat1 = toRad(a.latitude);
  const lat2 = toRad(b.latitude);
  const h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  return 2 * EARTH_RADIUS_MILES * Math.asin(Math.sqrt(h));
}
function checkServiceArea(params) {
  const { config, rooftop, pickup, delivery } = params;
  const radiusMiles = Number(config.radiusMiles ?? 0);
  if (!Number.isFinite(radiusMiles) || radiusMiles <= 0) return null;
  if (!config.byPickup && !config.byDelivery) return null;
  if (!rooftop) return null;
  const legs = [
    { leg: "pickup", coords: config.byPickup ? pickup : null },
    { leg: "delivery", coords: config.byDelivery ? delivery : null }
  ];
  for (const { leg, coords } of legs) {
    if (!coords) continue;
    const miles = distanceMiles(rooftop, coords);
    if (miles > radiusMiles) {
      return {
        leg,
        distanceMiles: Math.round(miles * 10) / 10,
        radiusMiles
      };
    }
  }
  return null;
}

// src/features/availability/slotWindows.ts
function buildDriverBusyRanges(params) {
  const { scenarios, timezone: timezone2, bufferMinutes, tier, driverSchedule, selectedDate } = params;
  const appointmentRanges = busyRangesFromScenarios(scenarios, timezone2);
  const bufferedAppointmentRanges = bufferMinutes > 0 ? appointmentRanges.map((range) => ({
    start: range.start,
    end: (0, import_dayjs.default)(range.end).add(bufferMinutes, "minutes").toDate()
  })) : appointmentRanges;
  const busyRanges = [...bufferedAppointmentRanges];
  if (tier === "lite") {
    const unavailableBlocks = calculateUnavailableBlocks(driverSchedule, selectedDate, timezone2);
    busyRanges.push(...unavailableBlocksToTimeRanges(unavailableBlocks));
  }
  return busyRanges;
}
function computeSlotWindows(params) {
  const { slots, busyRanges, dayStart, dayEnd, offsetMaxMinutes } = params;
  const offsetMaxMs = Math.max(0, offsetMaxMinutes) * 6e4;
  const gaps = findAvailableGaps(busyRanges, dayStart, dayEnd);
  return slots.map((slot) => {
    if (offsetMaxMs === 0) {
      return { earliestTime: slot.endTime, latestTime: slot.endTime };
    }
    const gap = gaps.find(
      (candidate) => candidate.start.getTime() <= slot.startTime.getTime() && candidate.end.getTime() >= slot.returnEndTime.getTime()
    );
    if (!gap) {
      return { earliestTime: slot.endTime, latestTime: slot.endTime };
    }
    const earlierRoomMs = slot.startTime.getTime() - gap.start.getTime();
    const laterRoomMs = gap.end.getTime() - slot.returnEndTime.getTime();
    return {
      earliestTime: new Date(slot.endTime.getTime() - Math.min(earlierRoomMs, offsetMaxMs)),
      latestTime: new Date(slot.endTime.getTime() + Math.min(laterRoomMs, offsetMaxMs))
    };
  });
}

// src/features/availability/getAppointmentAvailability.ts
var defaultLaneResolver = null;
function configureLaneResolver(resolver) {
  defaultLaneResolver = resolver;
}
function resetLaneResolver() {
  defaultLaneResolver = null;
}
async function fetchRooftopInfo(customerId, executor) {
  const customer = await getRooftopAvailabilityInfo({ customerId }, { executor });
  if (!customer || !customer.location) return null;
  return {
    tier: customer.tier,
    locationId: customer.location.id,
    timezone: customer.location.timezone,
    coordinates: toCoordinates(customer.location.latitude, customer.location.longitude)
  };
}
function toCoordinates(latitude, longitude) {
  const lat = Number(latitude);
  const lng = Number(longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (lat === 0 && lng === 0) return null;
  return { latitude: lat, longitude: lng };
}
async function fetchLocationCoordinates(locationIds, executor) {
  const rows = await getLocationCoordinates({ locationIds }, { executor });
  const byId = /* @__PURE__ */ new Map();
  for (const row of rows ?? []) {
    byId.set(Number(row.id), toCoordinates(row.latitude, row.longitude));
  }
  return byId;
}
async function fetchBusinessHours(locationId, executor) {
  const rows = await getLocationBusinessHours({ locationId }, { executor });
  return rows ?? [];
}
async function fetchScenarios(customerId, rangeStartIso, rangeEndIso, executor) {
  const scenarios = await getScenariosForAvailability(
    { customerId, rangeStart: rangeStartIso, rangeEnd: rangeEndIso },
    { executor }
  );
  return scenarios ?? [];
}
async function fetchActiveDriversWithSchedules(customerId, executor) {
  const drivers = await getActiveDriversForAvailability({ customerId }, { executor });
  return (drivers ?? []).map((driver) => ({
    id: driver.id,
    schedule: (driver.businesshours ?? []).map((row) => ({
      type: row.type,
      dayOfWeek: row.day_of_week ?? null,
      day: row.day ?? null,
      month: row.month ?? null,
      year: row.year ?? null,
      isOpen: row.is_open ?? false,
      timeBlocks: row.open_time && row.closed_time ? [{ openTime: row.open_time, closedTime: row.closed_time }] : []
    }))
  }));
}
async function getAppointmentAvailability(input) {
  const executor = resolveExecutor3(input.executor);
  const [rooftop, effectiveConfig] = await Promise.all([
    fetchRooftopInfo(input.customerId, executor),
    getCustomerConfig({ customerId: input.customerId, executor })
  ]);
  if (!rooftop) {
    throw new Error(`Rooftop not found: customerId=${input.customerId}`);
  }
  const timezone2 = rooftop.timezone;
  const resolvedTier = input.tier ?? rooftop.tier;
  const tier = resolvedTier === "lite" ? "lite" : "standard";
  const { appointment_management: am } = parseAppointmentConfig(effectiveConfig.appointment_management);
  const strategy = input.strategy ?? am.strategy;
  const envelope = enforcementEnvelope(am);
  if (!am.enabled) {
    return {
      rooftop_timezone: timezone2,
      eligible: false,
      reason: "APPOINTMENT_MANAGEMENT_DISABLED",
      driver_rows: [],
      ...envelope
    };
  }
  const serviceArea = await evaluateServiceArea({
    effectiveConfig,
    rooftop,
    originLocationId: input.originLocationId,
    destinationLocationId: input.destinationLocationId,
    executor
  });
  if (serviceArea) {
    return {
      rooftop_timezone: timezone2,
      eligible: false,
      reason: "OUT_OF_SERVICE_AREA",
      driver_rows: [],
      out_of_service_area: serviceArea,
      ...envelope
    };
  }
  let lane;
  let inverse;
  if (input.prefetchedLane) {
    lane = input.prefetchedLane.lane;
    inverse = input.prefetchedLane.inverse;
  } else {
    const resolver = input.laneResolver ?? defaultLaneResolver;
    if (!resolver) {
      throw new Error(
        "getAppointmentAvailability: no lane resolver configured. Call configureLaneResolver(resolveLaneWithRouting) at app startup, or pass `prefetchedLane` / `laneResolver` in the input."
      );
    }
    const resolved = await resolver({
      customerId: input.customerId,
      originLocationId: input.originLocationId,
      destinationLocationId: input.destinationLocationId,
      executor,
      correlationId: input.correlationId
    });
    if (!resolved.forward) {
      throw new Error("Lane resolver did not return a forward lane");
    }
    lane = resolved.forward;
    inverse = resolved.inverse;
  }
  const businessHoursRows = await fetchBusinessHours(rooftop.locationId, executor);
  const resolvedHours = resolveBusinessHours(
    businessHoursRows,
    rooftop.locationId,
    input.date,
    timezone2,
    tier
  );
  if (resolvedHours.isClosed) {
    return {
      rooftop_timezone: timezone2,
      eligible: false,
      reason: resolvedHours.closureName ? `CLOSED:${resolvedHours.closureName}` : "CLOSED",
      driver_rows: [],
      ...envelope
    };
  }
  const { startIso, endIso } = dayWindowIso(input.date, timezone2);
  const scenarios = await fetchScenarios(input.customerId, startIso, endIso, executor);
  const liteDrivers = tier === "lite" ? await fetchActiveDriversWithSchedules(input.customerId, executor) : [];
  const algorithm = getAlgorithm(strategy);
  const { allDriverScenarios, driverCount } = prepareDriverScenariosForAlgorithm({
    scenarios,
    tier,
    algorithm,
    driverCount: am.driverCount,
    bufferMinutes: am.moveBufferMinutes,
    timezone: timezone2,
    activeDrivers: tier === "lite" ? liteDrivers.map((d) => ({ id: d.id })) : void 0
  });
  if (driverCount === 0) {
    return {
      rooftop_timezone: timezone2,
      eligible: false,
      reason: "NO_DRIVERS_CONFIGURED",
      driver_rows: [],
      ...envelope
    };
  }
  const businessHoursLite = {
    openTime: resolvedHours.openTime,
    closeTime: resolvedHours.closeTime
  };
  const { dayStart, dayEnd } = parseBusinessHoursToDayBounds(
    resolvedHours.openTime,
    resolvedHours.closeTime,
    input.date,
    timezone2
  );
  const driver_rows = allDriverScenarios.map((driverScenarios, driverIndex) => {
    const driverId = tier === "lite" ? liteDrivers[driverIndex]?.id ?? null : -(driverIndex + 1);
    const driverSchedule = tier === "lite" ? liteDrivers[driverIndex]?.schedule : void 0;
    const slots = algorithm.generateTimeSlots({
      driverIndex,
      driverCount,
      allDriverScenarios,
      lane,
      businessHours: businessHoursLite,
      selectedDate: input.date,
      timezone: timezone2,
      bufferMinutes: am.moveBufferMinutes,
      tier,
      driverSchedule,
      scenarioKey: input.consumerAction ?? void 0
    });
    const busyRanges = buildDriverBusyRanges({
      scenarios: filterActuallyScheduled(driverScenarios, tier),
      timezone: timezone2,
      bufferMinutes: am.moveBufferMinutes,
      tier,
      driverSchedule,
      selectedDate: input.date
    });
    const windows = computeSlotWindows({
      slots,
      busyRanges,
      dayStart,
      dayEnd,
      offsetMaxMinutes: am.offsetMaxMinutes
    });
    return {
      driver_id: driverId,
      slots: attachDriverIdToSlots(slots, driverId).map((slot, slotIndex) => ({
        ...slot,
        earliestTime: windows[slotIndex]?.earliestTime,
        latestTime: windows[slotIndex]?.latestTime
      }))
    };
  });
  return {
    rooftop_timezone: timezone2,
    eligible: true,
    reason: null,
    driver_rows,
    ...envelope,
    // inverse is preserved on the result for callers that want to inspect it,
    // but it's not part of the public AvailabilityResult contract — it lives
    // on the (forward) `lane` we already used.
    ...inverse ? {} : {}
  };
}
async function evaluateServiceArea(params) {
  const { effectiveConfig, rooftop, originLocationId, destinationLocationId, executor } = params;
  const raw = effectiveConfig;
  const config = {
    radiusMiles: raw.serviceable_radius_miles == null ? null : Number(raw.serviceable_radius_miles),
    byPickup: raw.serviceable_radius_by_pickup === true,
    byDelivery: raw.serviceable_radius_by_delivery === true
  };
  const radius = Number(config.radiusMiles ?? 0);
  if (!Number.isFinite(radius) || radius <= 0) return null;
  if (!config.byPickup && !config.byDelivery) return null;
  if (!rooftop.coordinates) return null;
  const coords = await fetchLocationCoordinates([originLocationId, destinationLocationId], executor);
  return checkServiceArea({
    config,
    rooftop: rooftop.coordinates,
    pickup: coords.get(originLocationId) ?? null,
    delivery: coords.get(destinationLocationId) ?? null
  });
}
function enforcementEnvelope(am) {
  const forced = am.enabled && am.fullPlanningEnabled && am.enforcementMode === "forced";
  return {
    enforcement_mode: forced ? "forced" : "suggestion",
    offset_increment_minutes: am.offsetIncrementMinutes,
    offset_max_minutes: am.offsetMaxMinutes
  };
}
function dayWindowIso(date, timezoneStr) {
  const start = import_dayjs.default.tz(date, timezoneStr).startOf("day");
  const end = start.add(1, "day");
  return { startIso: start.toISOString(), endIso: end.toISOString() };
}
function attachDriverIdToSlots(slots, driverId) {
  return slots.map((slot) => ({ ...slot, driver_id: driverId }));
}

// src/features/availability/flattenToSlots.ts
function flattenToSlots(result) {
  const envelope = {
    enforcement_mode: result.enforcement_mode ?? "suggestion",
    offset_increment_minutes: result.offset_increment_minutes ?? 0,
    offset_max_minutes: result.offset_max_minutes ?? 0
  };
  if (!result.eligible) {
    return {
      rooftop_timezone: result.rooftop_timezone,
      eligible: false,
      reason: result.reason,
      ...envelope,
      ...result.out_of_service_area ? {
        out_of_service_area: {
          leg: result.out_of_service_area.leg,
          distance_miles: result.out_of_service_area.distanceMiles,
          serviceable_radius_miles: result.out_of_service_area.radiusMiles
        }
      } : {},
      slots: []
    };
  }
  const byAppointmentTime = /* @__PURE__ */ new Map();
  for (const row of result.driver_rows) {
    for (const slot of row.slots) {
      const appointment_time = slot.endTime.toISOString();
      const earliestMs = (slot.earliestTime ?? slot.endTime).getTime();
      const latestMs = (slot.latestTime ?? slot.endTime).getTime();
      const existing = byAppointmentTime.get(appointment_time);
      if (existing) {
        existing.driverIds.add(row.driver_id);
        existing.earliestMs = Math.min(existing.earliestMs, earliestMs);
        existing.latestMs = Math.max(existing.latestMs, latestMs);
      } else {
        byAppointmentTime.set(appointment_time, {
          pickup_start: slot.startTime.toISOString(),
          return_end: slot.returnEndTime.toISOString(),
          driverIds: /* @__PURE__ */ new Set([row.driver_id]),
          earliestMs,
          latestMs
        });
      }
    }
  }
  const slots = Array.from(byAppointmentTime.entries()).map(([appointment_time, { pickup_start, return_end, driverIds, earliestMs, latestMs }]) => ({
    pickup_start,
    appointment_time,
    return_end,
    available_drivers: driverIds.size,
    earliest_appointment_time: new Date(earliestMs).toISOString(),
    latest_appointment_time: new Date(latestMs).toISOString()
  })).sort((a, b) => a.appointment_time.localeCompare(b.appointment_time));
  return {
    rooftop_timezone: result.rooftop_timezone,
    eligible: true,
    reason: null,
    ...envelope,
    slots
  };
}

// src/features/availability/validateAppointmentTime.ts
import { resolveExecutor as resolveExecutor4 } from "@hopdrive/sdk-core";
import { getCustomerConfig as getCustomerConfig2 } from "@hopdrive/sdk-configs";
async function getEffectiveEnforcement(params) {
  const executor = resolveExecutor4(params.executor);
  const effectiveConfig = await getCustomerConfig2({ customerId: params.customerId, executor });
  const { appointment_management: am } = parseAppointmentConfig(effectiveConfig.appointment_management);
  const forced = am.enabled && am.fullPlanningEnabled && am.enforcementMode === "forced";
  return {
    mode: forced ? "forced" : "suggestion",
    offsetIncrementMinutes: am.offsetIncrementMinutes,
    offsetMaxMinutes: am.offsetMaxMinutes
  };
}
async function validateAppointmentTime(input) {
  const executor = resolveExecutor4(input.executor);
  const chosen = new Date(input.appointmentTime);
  if (Number.isNaN(chosen.getTime())) {
    return {
      valid: false,
      enforcement_mode: "forced",
      reason: "INVALID_APPOINTMENT_TIME",
      availability: null
    };
  }
  const enforcement = await getEffectiveEnforcement({ customerId: input.customerId, executor });
  if (enforcement.mode !== "forced") {
    return { valid: true, enforcement_mode: enforcement.mode, reason: null, availability: null };
  }
  const rooftop = await getRooftopAvailabilityInfo({ customerId: input.customerId }, { executor });
  if (!rooftop || !rooftop.location) {
    throw new Error(`Rooftop not found: customerId=${input.customerId}`);
  }
  const date = (0, import_dayjs.default)(chosen).tz(rooftop.location.timezone).format("YYYY-MM-DD");
  const availability = flattenToSlots(
    await getAppointmentAvailability({
      customerId: input.customerId,
      originLocationId: input.originLocationId,
      destinationLocationId: input.destinationLocationId,
      date,
      consumerAction: input.consumerAction,
      executor,
      correlationId: input.correlationId,
      laneResolver: input.laneResolver
    })
  );
  if (!availability.eligible) {
    return {
      valid: false,
      enforcement_mode: "forced",
      reason: availability.reason ?? "NOT_ELIGIBLE",
      availability
    };
  }
  const withinWindow = isTimeWithinOfferedSlots(availability, chosen);
  return {
    valid: withinWindow,
    enforcement_mode: "forced",
    reason: withinWindow ? null : "TIME_NOT_IN_SLOT_WINDOW",
    availability
  };
}
function isTimeWithinOfferedSlots(availability, time) {
  const ms = time.getTime();
  return availability.slots.some(
    (slot) => ms >= new Date(slot.earliest_appointment_time).getTime() && ms <= new Date(slot.latest_appointment_time).getTime()
  );
}

// src/features/eligibility/estimatedPricingMarkets.ts
var ESTIMATED_PRICING_MARKETS = {
  "Atlanta": {
    "city": "Atlanta",
    "state": "GA",
    "lat": 33.749,
    "lng": -84.388,
    "concierge": {
      "baseFee": 68.58,
      "class123PerMile": 3.66,
      "class45PerMile": 1.26,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 40.06,
      "class123PerMile": 1.41,
      "class45PerMile": 1.26,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "Austin": {
    "city": "Austin",
    "state": "TX",
    "lat": 30.2672,
    "lng": -97.7431,
    "concierge": {
      "baseFee": 72.07,
      "class123PerMile": 4.11,
      "class45PerMile": 1.44,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 42.06,
      "class123PerMile": 1.61,
      "class45PerMile": 1.44,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "Baltimore": {
    "city": "Baltimore",
    "state": "MD",
    "lat": 39.2904,
    "lng": -76.6122,
    "concierge": {
      "baseFee": 72.65,
      "class123PerMile": 4.06,
      "class45PerMile": 1.22,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 39.72,
      "class123PerMile": 1.37,
      "class45PerMile": 1.22,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "Boston": {
    "city": "Boston",
    "state": "MA",
    "lat": 42.3601,
    "lng": -71.0589,
    "concierge": {
      "baseFee": 76.68,
      "class123PerMile": 4.37,
      "class45PerMile": 1.32,
      "ecrAddon": 22,
      "carWashAddon": 37
    },
    "swap": {
      "baseFee": 42.68,
      "class123PerMile": 1.57,
      "class45PerMile": 1.32,
      "ecrAddon": 22,
      "carWashAddon": 37
    }
  },
  "Charlotte": {
    "city": "Charlotte",
    "state": "NC",
    "lat": 35.2271,
    "lng": -80.8431,
    "concierge": {
      "baseFee": 66.61,
      "class123PerMile": 3.56,
      "class45PerMile": 1.19,
      "ecrAddon": 19,
      "carWashAddon": 34
    },
    "swap": {
      "baseFee": 37.67,
      "class123PerMile": 1.27,
      "class45PerMile": 1.19,
      "ecrAddon": 19,
      "carWashAddon": 34
    }
  },
  "Chicago": {
    "city": "Chicago",
    "state": "IL",
    "lat": 41.8781,
    "lng": -87.6298,
    "concierge": {
      "baseFee": 69.34,
      "class123PerMile": 3.73,
      "class45PerMile": 1.22,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 39.92,
      "class123PerMile": 1.39,
      "class45PerMile": 1.22,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "Cincinnati": {
    "city": "Cincinnati",
    "state": "OH",
    "lat": 39.1031,
    "lng": -84.512,
    "concierge": {
      "baseFee": 67.54,
      "class123PerMile": 3.65,
      "class45PerMile": 1.22,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 38.77,
      "class123PerMile": 1.28,
      "class45PerMile": 1.22,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "Columbia": {
    "city": "Columbia",
    "state": "SC",
    "lat": 34.0007,
    "lng": -81.0348,
    "concierge": {
      "baseFee": 68.2,
      "class123PerMile": 3.72,
      "class45PerMile": 1.22,
      "ecrAddon": 19,
      "carWashAddon": 34
    },
    "swap": {
      "baseFee": 38.52,
      "class123PerMile": 1.35,
      "class45PerMile": 1.22,
      "ecrAddon": 19,
      "carWashAddon": 34
    }
  },
  "Columbus": {
    "city": "Columbus",
    "state": "OH",
    "lat": 39.9612,
    "lng": -82.9988,
    "concierge": {
      "baseFee": 71.29,
      "class123PerMile": 3.93,
      "class45PerMile": 1.22,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 38.77,
      "class123PerMile": 1.28,
      "class45PerMile": 1.22,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "Dallas": {
    "city": "Dallas",
    "state": "TX",
    "lat": 32.7767,
    "lng": -96.797,
    "concierge": {
      "baseFee": 68.82,
      "class123PerMile": 3.68,
      "class45PerMile": 1.44,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 42.06,
      "class123PerMile": 1.61,
      "class45PerMile": 1.44,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "Denver": {
    "city": "Denver",
    "state": "CO",
    "lat": 39.7392,
    "lng": -104.9903,
    "concierge": {
      "baseFee": 72.95,
      "class123PerMile": 3.99,
      "class45PerMile": 1.26,
      "ecrAddon": 22,
      "carWashAddon": 37
    },
    "swap": {
      "baseFee": 42.23,
      "class123PerMile": 1.52,
      "class45PerMile": 1.26,
      "ecrAddon": 22,
      "carWashAddon": 37
    }
  },
  "Detroit": {
    "city": "Detroit",
    "state": "MI",
    "lat": 42.3314,
    "lng": -83.0458,
    "concierge": {
      "baseFee": 75.74,
      "class123PerMile": 4.27,
      "class45PerMile": 1.39,
      "ecrAddon": 21,
      "carWashAddon": 36
    },
    "swap": {
      "baseFee": 42.62,
      "class123PerMile": 1.66,
      "class45PerMile": 1.39,
      "ecrAddon": 21,
      "carWashAddon": 36
    }
  },
  "Houston": {
    "city": "Houston",
    "state": "TX",
    "lat": 29.7604,
    "lng": -95.3698,
    "concierge": {
      "baseFee": 72.18,
      "class123PerMile": 4.12,
      "class45PerMile": 1.44,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 42.06,
      "class123PerMile": 1.61,
      "class45PerMile": 1.44,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "Indianapolis": {
    "city": "Indianapolis",
    "state": "IN",
    "lat": 39.7684,
    "lng": -86.1581,
    "concierge": {
      "baseFee": 65.12,
      "class123PerMile": 3.41,
      "class45PerMile": 1.16,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 38.35,
      "class123PerMile": 1.23,
      "class45PerMile": 1.16,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "Jacksonville": {
    "city": "Jacksonville",
    "state": "FL",
    "lat": 30.3322,
    "lng": -81.6557,
    "concierge": {
      "baseFee": 67.48,
      "class123PerMile": 3.65,
      "class45PerMile": 1.39,
      "ecrAddon": 19,
      "carWashAddon": 34
    },
    "swap": {
      "baseFee": 40.86,
      "class123PerMile": 1.59,
      "class45PerMile": 1.39,
      "ecrAddon": 19,
      "carWashAddon": 34
    }
  },
  "Kansas City": {
    "city": "Kansas City",
    "state": "MO",
    "lat": 39.0997,
    "lng": -94.5786,
    "concierge": {
      "baseFee": 68.1,
      "class123PerMile": 3.71,
      "class45PerMile": 1.22,
      "ecrAddon": 19,
      "carWashAddon": 34
    },
    "swap": {
      "baseFee": 38.52,
      "class123PerMile": 1.35,
      "class45PerMile": 1.22,
      "ecrAddon": 19,
      "carWashAddon": 34
    }
  },
  "Knoxville": {
    "city": "Knoxville",
    "state": "TN",
    "lat": 35.9606,
    "lng": -83.9207,
    "concierge": {
      "baseFee": 63.44,
      "class123PerMile": 3.24,
      "class45PerMile": 1.22,
      "ecrAddon": 19,
      "carWashAddon": 34
    },
    "swap": {
      "baseFee": 37.57,
      "class123PerMile": 1.26,
      "class45PerMile": 1.22,
      "ecrAddon": 19,
      "carWashAddon": 34
    }
  },
  "Las Vegas": {
    "city": "Las Vegas",
    "state": "NV",
    "lat": 36.1699,
    "lng": -115.1398,
    "concierge": {
      "baseFee": 70.73,
      "class123PerMile": 3.87,
      "class45PerMile": 1.39,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 42.06,
      "class123PerMile": 1.61,
      "class45PerMile": 1.39,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "Los Angeles": {
    "city": "Los Angeles",
    "state": "CA",
    "lat": 34.0522,
    "lng": -118.2437,
    "concierge": {
      "baseFee": 73.95,
      "class123PerMile": 4.19,
      "class45PerMile": 1.26,
      "ecrAddon": 22,
      "carWashAddon": 37
    },
    "swap": {
      "baseFee": 42.59,
      "class123PerMile": 1.56,
      "class45PerMile": 1.26,
      "ecrAddon": 22,
      "carWashAddon": 37
    }
  },
  "Louisville": {
    "city": "Louisville",
    "state": "KY",
    "lat": 38.2527,
    "lng": -85.7585,
    "concierge": {
      "baseFee": 67.77,
      "class123PerMile": 3.68,
      "class45PerMile": 1.22,
      "ecrAddon": 19,
      "carWashAddon": 34
    },
    "swap": {
      "baseFee": 37.57,
      "class123PerMile": 1.26,
      "class45PerMile": 1.22,
      "ecrAddon": 19,
      "carWashAddon": 34
    }
  },
  "Memphis": {
    "city": "Memphis",
    "state": "TN",
    "lat": 35.1495,
    "lng": -90.049,
    "concierge": {
      "baseFee": 63.64,
      "class123PerMile": 3.26,
      "class45PerMile": 1.22,
      "ecrAddon": 19,
      "carWashAddon": 34
    },
    "swap": {
      "baseFee": 37.57,
      "class123PerMile": 1.26,
      "class45PerMile": 1.22,
      "ecrAddon": 19,
      "carWashAddon": 34
    }
  },
  "Miami": {
    "city": "Miami",
    "state": "FL",
    "lat": 25.7617,
    "lng": -80.1918,
    "concierge": {
      "baseFee": 70.45,
      "class123PerMile": 3.85,
      "class45PerMile": 1.39,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 42.06,
      "class123PerMile": 1.61,
      "class45PerMile": 1.39,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "Milwaukee": {
    "city": "Milwaukee",
    "state": "WI",
    "lat": 43.0389,
    "lng": -87.9065,
    "concierge": {
      "baseFee": 72.28,
      "class123PerMile": 4.13,
      "class45PerMile": 1.22,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 39.72,
      "class123PerMile": 1.37,
      "class45PerMile": 1.22,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "Minneapolis": {
    "city": "Minneapolis",
    "state": "MN",
    "lat": 44.9778,
    "lng": -93.265,
    "concierge": {
      "baseFee": 68.63,
      "class123PerMile": 3.76,
      "class45PerMile": 1.26,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 40.27,
      "class123PerMile": 1.43,
      "class45PerMile": 1.26,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "Nashville": {
    "city": "Nashville",
    "state": "TN",
    "lat": 36.1627,
    "lng": -86.7816,
    "concierge": {
      "baseFee": 66.84,
      "class123PerMile": 3.48,
      "class45PerMile": 1.22,
      "ecrAddon": 19,
      "carWashAddon": 34
    },
    "swap": {
      "baseFee": 37.57,
      "class123PerMile": 1.26,
      "class45PerMile": 1.22,
      "ecrAddon": 19,
      "carWashAddon": 34
    }
  },
  "New Jersey": {
    "city": "New Jersey",
    "state": "NJ",
    "lat": 40.0583,
    "lng": -74.4057,
    "note": "State centroid - no single city specified",
    "concierge": {
      "baseFee": 84.61,
      "class123PerMile": 5.16,
      "class45PerMile": 1.39,
      "ecrAddon": 22,
      "carWashAddon": 37
    },
    "swap": {
      "baseFee": 46.52,
      "class123PerMile": 1.95,
      "class45PerMile": 1.39,
      "ecrAddon": 22,
      "carWashAddon": 37
    }
  },
  "New York City": {
    "city": "New York City",
    "state": "NY",
    "lat": 40.7128,
    "lng": -74.006,
    "concierge": {
      "baseFee": 118.28,
      "class123PerMile": 9.03,
      "class45PerMile": 1.74,
      "ecrAddon": 23,
      "carWashAddon": 38
    },
    "swap": {
      "baseFee": 52.99,
      "class123PerMile": 2.6,
      "class45PerMile": 1.74,
      "ecrAddon": 23,
      "carWashAddon": 38
    }
  },
  "Orlando": {
    "city": "Orlando",
    "state": "FL",
    "lat": 28.5383,
    "lng": -81.3792,
    "concierge": {
      "baseFee": 69.36,
      "class123PerMile": 3.74,
      "class45PerMile": 1.39,
      "ecrAddon": 19,
      "carWashAddon": 34
    },
    "swap": {
      "baseFee": 40.86,
      "class123PerMile": 1.59,
      "class45PerMile": 1.39,
      "ecrAddon": 19,
      "carWashAddon": 34
    }
  },
  "Philadelphia": {
    "city": "Philadelphia",
    "state": "PA",
    "lat": 39.9526,
    "lng": -75.1652,
    "concierge": {
      "baseFee": 79.5,
      "class123PerMile": 4.65,
      "class45PerMile": 1.32,
      "ecrAddon": 22,
      "carWashAddon": 37
    },
    "swap": {
      "baseFee": 42.59,
      "class123PerMile": 1.56,
      "class45PerMile": 1.32,
      "ecrAddon": 22,
      "carWashAddon": 37
    }
  },
  "Phoenix": {
    "city": "Phoenix",
    "state": "AZ",
    "lat": 33.4484,
    "lng": -111.9431,
    "concierge": {
      "baseFee": 67.99,
      "class123PerMile": 3.6,
      "class45PerMile": 1.22,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 39.09,
      "class123PerMile": 1.31,
      "class45PerMile": 1.22,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "Pittsburgh": {
    "city": "Pittsburgh",
    "state": "PA",
    "lat": 40.4406,
    "lng": -79.9959,
    "concierge": {
      "baseFee": 71.21,
      "class123PerMile": 3.92,
      "class45PerMile": 1.32,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 40.06,
      "class123PerMile": 1.41,
      "class45PerMile": 1.32,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "Portland": {
    "city": "Portland",
    "state": "OR",
    "lat": 45.5152,
    "lng": -122.6784,
    "concierge": {
      "baseFee": 78.93,
      "class123PerMile": 4.59,
      "class45PerMile": 1.16,
      "ecrAddon": 22,
      "carWashAddon": 37
    },
    "swap": {
      "baseFee": 40.96,
      "class123PerMile": 1.4,
      "class45PerMile": 1.16,
      "ecrAddon": 22,
      "carWashAddon": 37
    }
  },
  "Providence": {
    "city": "Providence",
    "state": "RI",
    "lat": 41.824,
    "lng": -71.4128,
    "concierge": {
      "baseFee": 75.39,
      "class123PerMile": 4.24,
      "class45PerMile": 1.26,
      "ecrAddon": 22,
      "carWashAddon": 37
    },
    "swap": {
      "baseFee": 42.48,
      "class123PerMile": 1.55,
      "class45PerMile": 1.26,
      "ecrAddon": 22,
      "carWashAddon": 37
    }
  },
  "Richmond": {
    "city": "Richmond",
    "state": "VA",
    "lat": 37.5407,
    "lng": -77.436,
    "concierge": {
      "baseFee": 64.37,
      "class123PerMile": 3.34,
      "class45PerMile": 1.16,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 38.55,
      "class123PerMile": 1.26,
      "class45PerMile": 1.16,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "Sacramento": {
    "city": "Sacramento",
    "state": "CA",
    "lat": 38.5816,
    "lng": -121.4944,
    "concierge": {
      "baseFee": 74.48,
      "class123PerMile": 4.05,
      "class45PerMile": 1.26,
      "ecrAddon": 22,
      "carWashAddon": 37
    },
    "swap": {
      "baseFee": 42.23,
      "class123PerMile": 1.52,
      "class45PerMile": 1.26,
      "ecrAddon": 22,
      "carWashAddon": 37
    }
  },
  "Salt Lake City": {
    "city": "Salt Lake City",
    "state": "UT",
    "lat": 40.7608,
    "lng": -111.891,
    "concierge": {
      "baseFee": 63.68,
      "class123PerMile": 3.27,
      "class45PerMile": 1.16,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 38.35,
      "class123PerMile": 1.23,
      "class45PerMile": 1.16,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "San Antonio": {
    "city": "San Antonio",
    "state": "TX",
    "lat": 29.4241,
    "lng": -98.4936,
    "concierge": {
      "baseFee": 70.66,
      "class123PerMile": 3.87,
      "class45PerMile": 1.44,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 42.06,
      "class123PerMile": 1.61,
      "class45PerMile": 1.44,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "San Diego": {
    "city": "San Diego",
    "state": "CA",
    "lat": 32.7157,
    "lng": -117.1611,
    "concierge": {
      "baseFee": 75.6,
      "class123PerMile": 4.36,
      "class45PerMile": 1.26,
      "ecrAddon": 22,
      "carWashAddon": 37
    },
    "swap": {
      "baseFee": 42.23,
      "class123PerMile": 1.52,
      "class45PerMile": 1.26,
      "ecrAddon": 22,
      "carWashAddon": 37
    }
  },
  "San Francisco": {
    "city": "San Francisco",
    "state": "CA",
    "lat": 37.7749,
    "lng": -122.4194,
    "concierge": {
      "baseFee": 81.37,
      "class123PerMile": 4.74,
      "class45PerMile": 1.26,
      "ecrAddon": 22,
      "carWashAddon": 37
    },
    "swap": {
      "baseFee": 42.59,
      "class123PerMile": 1.56,
      "class45PerMile": 1.26,
      "ecrAddon": 22,
      "carWashAddon": 37
    }
  },
  "San Jose": {
    "city": "San Jose",
    "state": "CA",
    "lat": 37.3382,
    "lng": -121.8863,
    "concierge": {
      "baseFee": 78.85,
      "class123PerMile": 4.48,
      "class45PerMile": 1.26,
      "ecrAddon": 22,
      "carWashAddon": 37
    },
    "swap": {
      "baseFee": 42.59,
      "class123PerMile": 1.56,
      "class45PerMile": 1.26,
      "ecrAddon": 22,
      "carWashAddon": 37
    }
  },
  "Seattle": {
    "city": "Seattle",
    "state": "WA",
    "lat": 47.6062,
    "lng": -122.3321,
    "concierge": {
      "baseFee": 95.74,
      "class123PerMile": 6.47,
      "class45PerMile": 1.22,
      "ecrAddon": 22,
      "carWashAddon": 37
    },
    "swap": {
      "baseFee": 41.55,
      "class123PerMile": 1.45,
      "class45PerMile": 1.22,
      "ecrAddon": 22,
      "carWashAddon": 37
    }
  },
  "South Bend": {
    "city": "South Bend",
    "state": "IN",
    "lat": 41.6764,
    "lng": -86.252,
    "concierge": {
      "baseFee": 68.36,
      "class123PerMile": 3.64,
      "class45PerMile": 1.16,
      "ecrAddon": 21,
      "carWashAddon": 36
    },
    "swap": {
      "baseFee": 38.74,
      "class123PerMile": 1.27,
      "class45PerMile": 1.16,
      "ecrAddon": 21,
      "carWashAddon": 36
    }
  },
  "Tampa": {
    "city": "Tampa",
    "state": "FL",
    "lat": 27.9506,
    "lng": -82.4572,
    "concierge": {
      "baseFee": 73.43,
      "class123PerMile": 4.14,
      "class45PerMile": 1.39,
      "ecrAddon": 20,
      "carWashAddon": 35
    },
    "swap": {
      "baseFee": 42.38,
      "class123PerMile": 1.64,
      "class45PerMile": 1.39,
      "ecrAddon": 20,
      "carWashAddon": 35
    }
  },
  "The Triangle, NC": {
    "city": "The Triangle",
    "state": "NC",
    "lat": 35.7996,
    "lng": -78.6382,
    "note": "Centered on Raleigh - the Triangle includes Raleigh, Durham, and Chapel Hill",
    "concierge": {
      "baseFee": 66.88,
      "class123PerMile": 3.49,
      "class45PerMile": 1.19,
      "ecrAddon": 21,
      "carWashAddon": 36
    },
    "swap": {
      "baseFee": 39.29,
      "class123PerMile": 1.33,
      "class45PerMile": 1.19,
      "ecrAddon": 21,
      "carWashAddon": 36
    }
  },
  "Washington D.C.": {
    "city": "Washington",
    "state": "DC",
    "lat": 38.9072,
    "lng": -77.0369,
    "concierge": {
      "baseFee": 71.86,
      "class123PerMile": 3.99,
      "class45PerMile": 1.28,
      "ecrAddon": 21,
      "carWashAddon": 36
    },
    "swap": {
      "baseFee": 42.04,
      "class123PerMile": 1.5,
      "class45PerMile": 1.28,
      "ecrAddon": 21,
      "carWashAddon": 36
    }
  }
};

// src/features/eligibility/findServiceableRooftop.ts
import { resolveExecutor as resolveExecutor5 } from "@hopdrive/sdk-core";
var METERS_PER_MILE = 1609.34;
function isValidCoordinate(coords) {
  const { latitude, longitude } = coords;
  if (typeof latitude !== "number" || typeof longitude !== "number") return false;
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return false;
  if (latitude < -90 || latitude > 90) return false;
  if (longitude < -180 || longitude > 180) return false;
  if (latitude === 0 && longitude === 0) return false;
  return true;
}
function getDistanceMeters(a, b) {
  const toRad = (deg) => deg * Math.PI / 180;
  const R = 6371e3;
  const dLat = toRad(b.latitude - a.latitude);
  const dLng = toRad(b.longitude - a.longitude);
  const sinDLat = Math.sin(dLat / 2);
  const sinDLng = Math.sin(dLng / 2);
  const ha = sinDLat * sinDLat + Math.cos(toRad(a.latitude)) * Math.cos(toRad(b.latitude)) * sinDLng * sinDLng;
  return Math.round(R * 2 * Math.atan2(Math.sqrt(ha), Math.sqrt(1 - ha)));
}
function findClosestMarket(lat, lng, markets) {
  const toRad = (deg) => deg * Math.PI / 180;
  const haversine = (lat1, lng1, lat2, lng2) => {
    const R = 3958.8;
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };
  let closest = null;
  for (const [key, market] of Object.entries(markets)) {
    const distance = haversine(lat, lng, market.lat, market.lng);
    if (!closest || distance < closest.distance) {
      closest = { key, market, distance };
    }
  }
  return closest;
}
function marketPricingToMileageBands(pricing) {
  const { baseFee, class123PerMile, class45PerMile } = pricing;
  const class45TotalPerMile = class123PerMile + class45PerMile;
  return [
    {
      distance_start: 0,
      distance_end: 10,
      type: "flat",
      class_1_rate: 0,
      class_2_rate: 0,
      class_3_rate: 0,
      class_4_rate: 0,
      class_5_rate: 0,
      class_6_rate: 0,
      class_1_flat_rate: baseFee,
      class_2_flat_rate: baseFee,
      class_3_flat_rate: baseFee,
      class_4_flat_rate: baseFee,
      class_5_flat_rate: baseFee,
      class_6_flat_rate: baseFee,
      class: "stranded"
    },
    {
      distance_start: 10,
      distance_end: 250,
      type: "flatPlusPer",
      class_1_rate: class123PerMile,
      class_2_rate: class123PerMile,
      class_3_rate: class123PerMile,
      class_4_rate: class45TotalPerMile,
      class_5_rate: class45TotalPerMile,
      class_6_rate: class45TotalPerMile,
      class_1_flat_rate: baseFee,
      class_2_flat_rate: baseFee,
      class_3_flat_rate: baseFee,
      class_4_flat_rate: baseFee,
      class_5_flat_rate: baseFee,
      class_6_flat_rate: baseFee,
      class: "stranded"
    }
  ];
}
async function resolveAddresses(input) {
  const { pickup, delivery, geocoder } = input;
  if (isValidCoordinate(pickup) && isValidCoordinate(delivery)) {
    return {
      pickupCoords: { latitude: pickup.latitude, longitude: pickup.longitude },
      deliveryCoords: { latitude: delivery.latitude, longitude: delivery.longitude },
      methodology: "coords",
      fullPickupAddress: null,
      fullDeliveryAddress: null
    };
  }
  const hasFullPickupAddress = !!(pickup.address_one && pickup.city && pickup.state && pickup.zip);
  const hasFullDeliveryAddress = !!(delivery.address_one && delivery.city && delivery.state && delivery.zip);
  if (!hasFullPickupAddress || !hasFullDeliveryAddress) {
    return null;
  }
  if (!geocoder) {
    throw new Error("findServiceableRooftop: geocoder is required when addresses are passed without coordinates");
  }
  const fullPickupAddress = `${pickup.address_one}, ${pickup.city}, ${pickup.state} ${pickup.zip}, USA`;
  const fullDeliveryAddress = `${delivery.address_one}, ${delivery.city}, ${delivery.state} ${delivery.zip}, USA`;
  const [pickupCoords, deliveryCoords] = await Promise.all([
    geocoder({ addressString: fullPickupAddress }),
    geocoder({ addressString: fullDeliveryAddress })
  ]);
  if (!pickupCoords || !deliveryCoords) {
    throw new Error("findServiceableRooftop: geocoder returned no coordinates for one or both addresses");
  }
  return {
    pickupCoords,
    deliveryCoords,
    methodology: "addresses",
    fullPickupAddress,
    fullDeliveryAddress
  };
}
function flattenMileageBands(workflowsets) {
  return (workflowsets ?? []).map((workflowset) => ({
    id: workflowset.id,
    name: workflowset.name,
    description: workflowset.description,
    type: workflowset.type,
    active_contracts: (workflowset.active_contracts ?? []).map((contract) => ({
      begin_date: contract.begin_date,
      end_date: contract.end_date,
      mileage_bands: (contract.contract_rules ?? []).flatMap((rule) => rule.raterules ?? [])
    }))
  }));
}
async function findServiceableRooftop(input) {
  if (!input.customerId && !input.organizationId) {
    throw new Error("findServiceableRooftop: customerId or organizationId is required");
  }
  const executor = resolveExecutor5(input.executor);
  const resolved = await resolveAddresses(input);
  if (!resolved) {
    throw new Error("findServiceableRooftop: invalid coordinates and incomplete address fields");
  }
  const customersResult = input.organizationId ? await getOrganizationRooftopsByOrganizationId({ organizationId: input.organizationId }, { executor }) : await getOrganizationRooftopsByCustomerId({ customerId: input.customerId }, { executor });
  const customersForOrg = customersResult ?? [];
  if (!customersForOrg || customersForOrg.length === 0) {
    throw new Error("findServiceableRooftop: no rooftop or organization found");
  }
  const organizationRaw = customersForOrg[0].organization;
  if (!organizationRaw) {
    throw new Error("findServiceableRooftop: customer row has no organization");
  }
  const organization = { id: organizationRaw.id, name: organizationRaw.name };
  const customers = (organizationRaw.customers ?? []).map((customer) => ({
    ...customer,
    workflowsets: flattenMileageBands(customer.workflowsets)
  }));
  if (customers.length === 0) {
    throw new Error("findServiceableRooftop: no rooftops found for organization");
  }
  const eligibleCustomers = customers.filter(
    (customer) => customer.location && typeof customer.location.latitude === "number" && typeof customer.location.longitude === "number" && (customer.serviceable_radius_miles ?? 0) > 0 && (customer.serviceable_radius_by_pickup || customer.serviceable_radius_by_delivery)
  ).map((customer) => {
    const center = customer.location;
    return {
      ...customer,
      location: center,
      distanceFromPickup: getDistanceMeters(resolved.pickupCoords, center),
      distanceFromDelivery: getDistanceMeters(resolved.deliveryCoords, center)
    };
  });
  if (eligibleCustomers.length === 0) {
    return {
      rooftop: null,
      organization,
      methodology: resolved.methodology,
      fullPickupAddress: resolved.fullPickupAddress,
      fullDeliveryAddress: resolved.fullDeliveryAddress,
      pickupCoords: resolved.pickupCoords,
      deliveryCoords: resolved.deliveryCoords
    };
  }
  const pickupServiceable = eligibleCustomers.filter((c) => c.serviceable_radius_by_pickup).filter((c) => c.distanceFromPickup < (c.serviceable_radius_miles ?? 0) * METERS_PER_MILE);
  const deliveryServiceable = eligibleCustomers.filter((c) => c.serviceable_radius_by_delivery).filter((c) => c.distanceFromDelivery < (c.serviceable_radius_miles ?? 0) * METERS_PER_MILE);
  const serviceable = [...pickupServiceable, ...deliveryServiceable];
  if (serviceable.length === 0) {
    return {
      rooftop: null,
      organization,
      methodology: resolved.methodology,
      fullPickupAddress: resolved.fullPickupAddress,
      fullDeliveryAddress: resolved.fullDeliveryAddress,
      pickupCoords: resolved.pickupCoords,
      deliveryCoords: resolved.deliveryCoords
    };
  }
  const nearest = serviceable.reduce(
    (prev, current) => current.distanceFromPickup < prev.distanceFromPickup ? current : prev,
    serviceable[0]
  );
  const rooftop = {
    id: nearest.id,
    name: nearest.name,
    serviceable_radius_miles: nearest.serviceable_radius_miles,
    serviceable_radius_by_pickup: nearest.serviceable_radius_by_pickup,
    serviceable_radius_by_delivery: nearest.serviceable_radius_by_delivery,
    center: nearest.location,
    workflowsets: nearest.workflowsets,
    distanceFromPickup: nearest.distanceFromPickup,
    distanceFromDelivery: nearest.distanceFromDelivery
  };
  return {
    rooftop,
    organization,
    methodology: resolved.methodology,
    fullPickupAddress: resolved.fullPickupAddress,
    fullDeliveryAddress: resolved.fullDeliveryAddress,
    pickupCoords: resolved.pickupCoords,
    deliveryCoords: resolved.deliveryCoords
  };
}
function buildProspectRooftop(input) {
  const { organization, pickupCoords, prospectOrgIds, defaultMileageBands, estimatedPricingMarkets } = input;
  if (!organization.id || !prospectOrgIds.includes(organization.id)) {
    return null;
  }
  const markets = estimatedPricingMarkets ?? ESTIMATED_PRICING_MARKETS;
  const closest = findClosestMarket(pickupCoords.latitude, pickupCoords.longitude, markets);
  const mileageBands = closest && closest.distance <= 400 ? marketPricingToMileageBands(closest.market.concierge) : defaultMileageBands;
  return {
    id: null,
    name: `${organization.name} - Prospect Rooftop`,
    serviceable_radius_miles: null,
    serviceable_radius_by_pickup: true,
    serviceable_radius_by_delivery: true,
    center: null,
    workflowsets: [
      {
        id: null,
        name: "Estimated Pricing",
        description: "Estimated pricing, contact your account rep to setup a rooftop in this area. Pricing subject to projected volume.",
        type: "estimate",
        active_contracts: [
          {
            begin_date: null,
            end_date: null,
            mileage_bands: mileageBands
          }
        ]
      }
    ]
  };
}
export {
  ALGORITHMS,
  APPOINTMENT_PAYMENT_MODE,
  APPOINTMENT_SOURCE,
  APPOINTMENT_STATUS,
  APPOINTMENT_TYPE,
  AppointmentNotFoundError,
  AppointmentValidationError,
  BalanceDriversV1,
  CONSUMER_PAY_DISABLED_REASON,
  CONSUMER_PAY_ENABLED,
  CONSUMER_VEHICLE_DIRECTION,
  DEFAULT_ALGORITHM,
  ESTIMATED_PRICING_MARKETS,
  ImmutableFieldError,
  InvalidStatusTransitionError,
  KNOWN_APPOINTMENT_TYPES,
  KNOWN_CONSUMER_VEHICLE_DIRECTIONS,
  MaxFirstDriverV1,
  SLOT_ROUNDING_MINUTES,
  STATUS_TRANSITIONS,
  ScenarioKey,
  TYPES_REQUIRING_DELIVERY_LOCATION,
  TYPES_REQUIRING_PICKUP_LOCATION,
  assignDriverRow,
  buildDriverBusyRanges,
  buildProspectRooftop,
  calculateMovePairTimes,
  calculateScenarioDuration,
  calculateTotalDuration,
  calculateUnavailableBlocks,
  checkMoveOverlap,
  checkServiceArea,
  computeSlotWindows,
  configureLaneResolver,
  createAppointment,
  createFetchExecutor2 as createFetchExecutor,
  distanceMiles,
  distributeEvenlyByDuration,
  distributeScenarios,
  filterPastSlots,
  findAvailableGaps,
  findClosestMarket,
  findServiceableRooftop,
  flattenToSlots,
  formatDisplayLabel,
  generateGapBasedSlots,
  generateSlotsInGap,
  getAlgorithm,
  getAlgorithmDescriptions,
  getAppointment2 as getAppointment,
  getAppointmentAvailability,
  getAppointmentByExternalId2 as getAppointmentByExternalId,
  getAppointmentOrThrow,
  getAvailableAlgorithms,
  getEffectiveEnforcement,
  getLogger,
  getPersistedRowNumber,
  getScenarioStartTime,
  getScenarioTimeRange,
  getTimeRangesFromScenarios,
  getTimingMove,
  getUnavailableBlockLabel,
  getValidTransitions,
  hasConflict,
  hasRideMove,
  init,
  isAnyConciergeScenario,
  isConciergeLoanerScenario,
  isConciergePickupScenario,
  isConciergeReturnScenario,
  isConciergeScenario,
  isConsumerPayRefused,
  isInitialized,
  isKnownAppointmentType,
  isKnownConsumerVehicleDirection,
  isTerminalStatus,
  isTimeWithinOfferedSlots,
  isValidTransition,
  linkScenario2 as linkScenario,
  marketPricingToMileageBands,
  mergeOverlappingRanges,
  parseAppointmentConfig,
  prepareDriverScenariosForAlgorithm,
  rangesOverlap,
  resetAppointmentsConfig,
  resetDefaultExecutor,
  resetLaneResolver,
  resolveBusinessHours,
  resolveExecutor,
  sortScenariosByTime,
  unavailableBlocksToTimeRanges,
  updateAppointment2 as updateAppointment,
  updateStatus,
  validateAppointment,
  validateAppointmentTime,
  validateCreateInput,
  validateUpdateChanges
};
//# sourceMappingURL=index.mjs.map